export const member_agreement = [
  {
    title: "제 1조 (목적)",
    description: [
      {
        id: "1-1",
        sub_title:
          "이 약관은 주식회사 메디올로지(이하 “회사”라 함)가 제공하는 헬시어 서비스 이용과 관련하여 회사와 이용자(이라 “회원”이라 함)간에 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 2조 (정의)",
    description: [
      {
        id: "2-1",
        sub_title: "이 약관에서 사용하는 용어의 정의는 다음과 같습니다.",
        sub_description: [],
      },
      {
        id: "2-2",
        sub_title:
          "1. “서비스”라 함은 구현되는 단말기(PC, TV, 휴대형단말기 등의 각종 유무선 장치를 포함)와 상관없이 “회원”이 이용할 수 있는 헬시어과 관련 제반 서비스를 의미합니다.",
        sub_description: ["헬시어 서비스", "기타 회사가 정하는 서비스"],
      },
      {
        id: "2-3",
        sub_title:
          "2. “헬시어 서비스”라 함은 감별진단, 병원예약, 커뮤니티 이용, 개인건강정보 관리, 병원 및 기타 의료정보 제공 등 “회사”가 “회원”에게 제공하는 서비스를 말합니다",
        sub_description: [],
      },
      {
        id: "2-4",
        sub_title:
          "3. “회원”이라 함은 이 약관에 동의하고, 이용계약(이하 “회원가입”이라 함)을 하여 따라 “회사”와 이용계약을 체결하고 “회사”가 제공하는 제반 서비스를 이용할 수 있는 자격을 부여 받은 자를 뜻합니다.",
        sub_description: [],
      },
      {
        id: "2-5",
        sub_title:
          "4. “기타 회사가 정하는 서비스”라 함은 “회사”가 추가 개발하거나 다른 회사와의 제휴 계약 등을 통해 “회원”에게 제공하는 일체 서비스를 의미합니다.",
        sub_description: [],
      },
      {
        id: "2-6",
        sub_title:
          "5. “아이디(ID)”라 함은 “회원”의 식별과 “헬시어 서비스” 이용을 위하여 “회원”이 정하고 “회사”가 승인하는 문자와 숫자의 조합을 이메일 또는 간편로그인 계정을 의미합니다.",
        sub_description: [],
      },
      {
        id: "2-7",
        sub_title:
          "6. “비밀번호”라 함은 “회원”이 부여 받은 “아이디와 일치되는 ”회원“임을 확인하고 비밀보호를 위해 “회원”자신이 정한 문자 또는 숫자의 조합을 의미합니다.",
        sub_description: [],
      },
      {
        id: "2-8",
        sub_title:
          "7. “단말기”’라 함은 서비스에 접속하기 위해 회원이 이용하는 개인용 컴퓨터, PDA, 휴대전화, 태블릿PC 등의 전산장치를 말합니다.",
        sub_description: [],
      },
      {
        id: "2-9",
        sub_title:
          "8. “해지”라 함은 회사 또는 회원이 이용계약을 해약하는 것을 말합니다.",
        sub_description: [],
      },
      {
        id: "2-10",
        sub_title:
          "9. “게시물”이라 함은 “회원”이 “서비스”를 이용함에 있어 서비스 상에 게시한 부호ㆍ문자ㆍ음성ㆍ음향ㆍ화상ㆍ동영상 등의 정보 형태의 글, 사진, 동영상 및 각종 파일과 링크 등을 의미합니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 3조 (약관의 게시와 개정)",
    description: [
      {
        id: "3-1",
        sub_title:
          "1. “회사”는 이 약관의 내용을 “회원”이 쉽게 알 수 있도록 서비스 내 페이지 화면에 게시합니다.",
        sub_description: [],
      },
      {
        id: "3-2",
        sub_title:
          "2. “회사”는 “약관의 규제에 관한 법률”, “정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 “정보통신망법”)” 등 관련 법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.",
        sub_description: [],
      },
      {
        id: "3-3",
        sub_title:
          "3. “회사”가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 제 1 항 규정에 따라 그 개정약관의 적용일자 14일 전부터 적용일자 전일까지 공지합니다. 다만, 회원에게 중요한 약관을 개정하는 경우에는 개정약관의 적용일자 30일전부터 적용일자까지 공지합니다.",
        sub_description: [],
      },
      {
        id: "3-4",
        sub_title:
          "4. 회사가 전항에 따라 개정약관을 공지 또는 통지하면서 회원에게 30일 기간 내에 의사표시를 하지 않으면 의사표시가 표명된 것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 회원이 명시적으로 거부의 의사표시를 하지 아니한 경우 회원이 개정약관에 동의한 것으로 봅니다.",
        sub_description: [],
      },
      {
        id: "3-5",
        sub_title:
          "5. 회원이 개정약관의 적용에 동의하지 않는 경우 회사는 개정 약관의 내용을 적용할 수 없으며, 이 경우 회원은 이용계약을 해지할 수 있습니다. 다만, 기존 약관을 적용할 수 없는 특별한 사정이 있는 경우에는 회사는 이용계약을 해지할 수 있습니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 4조 (약관의 해석)",
    description: [
      {
        id: "4-1",
        sub_title:
          "“회사”는 필요한 경우, 개별 서비스에 대해서는 별도의 이용약관 및 정책(이하 “서비스 별 안내 등”라 합니다)을 둘 수 있으며, 해당 내용이 이 약관과 상충할 경우에는 “서비스 별 안내 등”이 우선하여 적용됩니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 5조 (이용약관 체결)",
    description: [
      {
        id: "5-1",
        sub_title:
          "1. 이용계약은 “회원”이 되고자 하는 자가 약관의 내용에 대하여 동의를 한 다음 회원 가입신청을 하고 “회사”가 이러한 신청에 대하여 승낙함으로써 체결됩니다.",
        sub_description: [],
      },
      {
        id: "5-2",
        sub_title:
          "2. “회사”는 다음 각 호에 해당하는 신청에 대해서는 승낙을 하지 않거나 사후에 이용 계약을 해지할 수 있습니다.",
        sub_description: [],
      },
      {
        id: "5-3",
        sub_title:
          "3. 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우, 단 “회사”의 회원 재가입 승낙을 얻은 경우에는 예외로 함.",
        sub_description: [],
      },
      {
        id: "5-4",
        sub_title: "4. 실명이 아니거나 타인의 명의를 이용한 경우",
        sub_description: [],
      },
      {
        id: "5-5",
        sub_title:
          "5. 허위의 정보를 기재하거나, “회사”가 제시하는 내용을 기재하지 않은 경우",
        sub_description: [],
      },
      {
        id: "5-6",
        sub_title:
          "6. “회원”의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우",
        sub_description: [],
      },
      {
        id: "5-7",
        sub_title: "7. 만 14세 미만의 아동인 경우",
        sub_description: [],
      },
      {
        id: "5-8",
        sub_title:
          "8. 제1항에 따른 신청에 있어 “회사”는 전문기관을 통한 “회원”의 실명확인 및 본인인증을 요청할 수 있습니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 6조 (서비스 제공 중지)",
    description: [
      {
        id: "6-1",
        sub_title:
          "1. “회원”은 “회사”가 제공하는 서비스에 대해 언제든지 사용 여부를 결정할 수 있으며, “회사”는 “회원”의 서비스 사용 의사가 없을 경우 서비스 제공을 중지합니다.",
        sub_description: [],
      },
      {
        id: "6-2",
        sub_title: "2. “회사”가 제공하는 서비스는 다음과 같습니다.",
        sub_description: [],
        sub_table: [
          {
            id: "6-2-1",
            title: "서비스",
            description: "항목 서비스 내용",
          },
          {
            id: "6-2-2",
            title: "헬시어 서비스",
            description:
              "감별진단 서비스, 병원 접수/예약 서비스, 건강캘린더 서비스, 건강체크리스트 서비스",
          },
        ],
      },
      {
        id: "6-3",
        sub_title:
          "“회원”이 모바일/PC로 감별진단을 진행하고 결과를 확인할 수 있고, 이에 따라 해당 진료과의 병•의원을 예약하고 진료를 받을 수 있는 서비스",
        sub_description: [],
        sub_table: [
          {
            id: "6-3-1",
            title: "대기현황 서비스",
            description:
              "접수 또는 내원한 병•의원의 진료 대기순번을 안내해주는 서비스",
          },
          {
            id: "6-3-2",
            title: "결제 서비스",
            description:
              "“회원”이 지정•등록한 결제 수단을 이용하여 모바일로 진료비를 결제하는 서비스",
          },
          {
            id: "6-3-3",
            title: "병의원 연계 서비스",
            description:
              "병•의원에서 시행한 검사에 대해, 완료 알림 및 결과를 제공해주고, “회원”의 병•의원에서 검진 받는 환자 대상으로 검진 문진 및 결과를 제공해주는 서비스",
          },
          {
            id: "6-3-4",
            title: "기타 서비스",
            description:
              "“회사”가 추가 개발하거나, 다른 회사와의 제휴 계약 등을 통해 제공하는 “기타 서비스”",
          },
        ],
      },
      {
        id: "6-4",
        sub_title:
          "3. “회사”는 다음 각호에 해당하는 경우 서비스의 제공을 중지할 수 있습니다.",
        sub_description: [
          "1) 설비의 보수 등을 위하여 부득이한 경우\n2) 전기통신 사업법에 규정된 기간통신 사업자가 전기 통신서비스를 중지하는 경우\n3) 천재지변 등으로 인해 서비스제공자가 불가피하게 서비스를 제공할 수 없는 사유가 발생한 경우\n4) 회원이 이용해지를 요청한 경우\n5) 회원의 폐업/휴업 등을 포함하여, 회원의 사유로 인해 1개월 이상 서비스 이용이 중지된 경우",
        ],
      },
      {
        id: "6-5",
        sub_title:
          "4. “회사”는 서비스제공자의 경영, 정책, 운영 그리고 기술상의 이유로 무료로 제공되는 서비스의 전부 또는 일부를 변경(유료화 포함) 또는 중단할 수 있으며, 이에 대하여 관련 법에 특별한 규정이 없는 한 회원에게 별도의 보상을 하지 않습니다.",
        sub_description: [],
      },
      {
        id: "6-6",
        sub_title:
          "5. 본 조에 의해 서비스가 변경 또는 중단되는 경우에는 그 변경 또는 중단 사실을 서비스 페이지 내에 적용일 14일전부터 게시하여 공지합니다.",
        sub_description: [],
      },
      {
        id: "6-7",
        sub_title:
          "6. 회사는 “서비스”를 일정범위로 분할하여 각 범위 별로 이용가능시간을 별도로 지정할 수 있습니다. 다만, 이러한 경우에는 그 내용을 사전에 공지합니다.",
        sub_description: [],
      },
      {
        id: "6-8",
        sub_title:
          "7. “회사”는 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며, 정기점검시간은 서비스제공화면에 공지한 바에 따릅니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 7조 (“서비스”의 변경)",
    description: [
      {
        id: "7-1",
        sub_title:
          "1. “회사”는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 “서비스”를 본 계약에서 정한 범위 내에서 변경할 수 있습니다.",
        sub_description: [],
      },
      {
        id: "7-2",
        sub_title:
          "2. “서비스”의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우에는 변경사유, 변경될 서비스의 내용 및 제공일자 등은 그 변경 전에 해당 서비스 초기화면에 게시하여야 합니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 8조 (회원탈퇴 및 자격상실 등)",
    description: [
      {
        id: "8-1",
        sub_title:
          "1. “회원”은 언제든지 고객센터를 통하여 이용계약 탈퇴 및 신청을 할 수 있으며, “회사”는 관련법 등이 정하는 바에 따라 이를 즉시 처리하여야 합니다.",
        sub_description: [],
      },
      {
        id: "8-2",
        sub_title:
          "2. 회원이 다음 각 호의 사유에 해당하는 경우, “회사”는 회원자격을 제한 및/또는 정지시킬 수 있습니다.",
        sub_description: [
          "1) 회원이 제15조 제1항 각 호의 행위를 한 경우\n2) 다른 회원의 “서비스” 이용을 방해하거나 그 정보를 도용하는 등 전자상거래 질서를 위협하는 경우\n3) “회사”를 이용하여 법령 또는 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우\n4) 회사가 회원 자격을 제한∙정지 시킨 후, 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우 회사는 회원자격을 상실시킬 수 있습니다.",
        ],
      },
      {
        id: "8-3",
        sub_title:
          "회사가 회원자격을 상실시키는 경우에는 회원등록을 말소합니다. 이 경우 회원에게 이를 통지하고, 회원등록 말소 전에 최소한 30일 이상의 기간을 정하여 소명할 기회를 부여합니다. 만약 회원이 통지를 받은 날로부터 30일 내에 소명하고, 그 내용이 정당하다고 회사가 판단하는 경우 회사는 회원 자격을 원복해 줍니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 9조 (회원정보의 변경)",
    description: [
      {
        id: "9-1",
        sub_title:
          "1. “회원”은 서비스 내 페이지 화면을 통하여 언제든지 본인의 정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 실명, 아이디 등은 수정이 불가능합니다.",
        sub_description: [],
      },
      {
        id: "9-2",
        sub_title:
          "2. “회원”은 회원가입신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 전자우편 기타 방법으로 “회사”에 대하여 그 변경사항을 알려야 합니다.",
        sub_description: [],
      },
      {
        id: "9-3",
        sub_title:
          "제2항의 변경사항을 “회사”에 알리지 않아 발생한 불이익에 대하여 “회사”는 책임지지 않습니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 10조 (“회원”의 “아이디” 및 “비밀번호”의 관리에 대한 의무)",
    description: [
      {
        id: "10-1",
        sub_title:
          "1. ”회원”의 “아이디”는 원칙적으로 변경이 불가하며 부득이한 사유로 인하여 변경하고자 하는 경우에는 고객센터를 통하여 변경하여야 합니다. “회원”의 “아이디”와 “비밀번호”에 관한 관리책임은 “회원”에게 있습니다.",
        sub_description: [],
      },
      {
        id: "10-2",
        sub_title:
          "2. “회사”는 “회원”의 “아이디”가 개인정보 유출 우려가 있거나, 반사회적 또는 미풍양속에 어긋나거나 “회사” 및 “회사”의 운영자로 오인할 우려가 있는 경우, 해당 “아이디”의 이용을 제한할 수 있습니다.",
        sub_description: [],
      },
      {
        id: "10-3",
        sub_title:
          "3. “회원”은 “아이디” 및 “비밀번호”가 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 이를 즉시 “회사”에 통지하고 “회사”의 안내에 따라야 합니다.",
        sub_description: [],
      },
      {
        id: "10-4",
        sub_title:
          "4. 제3항의 경우에 해당 “회원”이 “회사”에 그 사실을 통지하지 않거나, 통지한 경우에도 “회사”의 안내에 따르지 않아 발생한 불이익에 대하여 “회사”는 책임지지 않습니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 11조 (개인정보보호 의무)",
    description: [
      {
        id: "11-1",
        sub_title:
          "1. “회사”는 “정보통신망법” 및 “개인정보보호법” 등 관계 법령이 정하는 바에 따라 “회원”의 개인정보를 보호하기 위해 노력합니다.",
        sub_description: [],
      },
      {
        id: "11-2",
        sub_title:
          "2. 개인정보의 보호 및 사용에 대해서는 관련법 및 “회사”의 개인정보처리방침이 적용됩니다.",
        sub_description: [],
      },
      {
        id: "11-3",
        sub_title:
          "3. “회사”의 공식 사이트 이외의 링크된 사이트에서는 “회사”의 개인정보처리방침이 적용되지 않습니다.",
        sub_description: [],
      },
      {
        id: "11-4",
        sub_title:
          "4. “회사”는 회원의 정보 수집 시 반드시 당해 회원의 동의를 얻어 필요한 최소한의 정보만을 수집하며, 회원은 온라인을 통해서 수시로 본인의 신상정보를 열람, 정정 또는 삭제할 수 있습니다.",
        sub_description: [],
      },
      {
        id: "11-5",
        sub_title:
          "5. “회사”가 제3자에게 회원의 개인정보를 제공할 필요가 있는 경우 개인정보를 제공받는 자, 개인정보를 제공받는 자의 개인정보 이용목적, 제공하는 개인정보의 항목, 개인정보를 제공받는 자의 개인정보 보유 및 이용기간을 회원에게 알리고 동의를 받아야 합니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 12조 (“회원”에 대한 통지)",
    description: [
      {
        id: "12-1",
        sub_title:
          "1. “회사”가 “회원”에 대한 통지를 하는 경우 이 약관에 별도 규정이 없는 한 서비스 내 페이지, 전자우편주소, 전자쪽지 등으로 할 수 있습니다.",
        sub_description: [],
      },
      {
        id: "12-2",
        sub_title:
          "2. “회사”는 “회원” 전체에 대한 통지의 경우 7일 이상 “회사”의 게시판에 게시함으로써 제1항의 통지에 갈음할 수 있습니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 13조 (“회사”의 의무)",
    description: [
      {
        id: "13-1",
        sub_title:
          "1. “회사”는 “회원”이 안전하게 “서비스”를 이용할 수 있도록 개인정보(신용정보 포함)보호를 위해 보안시스템을 갖추어야 하며 개인정보처리방침을 공시하고 준수합니다.",
        sub_description: [],
      },
      {
        id: "13-2",
        sub_title:
          "2. “회사”는 서비스이용과 관련하여 발생하는 회원의 불만 또는 피해구제요청을 적절하게 처리할 수 있도록 필요한 인력 및 시스템을 구비합니다.",
        sub_description: [],
      },
      {
        id: "13-3",
        sub_title:
          "3. “회사”는 서비스이용과 관련하여 “회원”으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를 처리하여야 합니다. “회원”이 제기한 의견이나 불만사항에 대해서는 게시판을 활용하거나 전자우편 등을 통하여 “회원”에게 처리과정 및 결과를 전달합니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 14조 (“회원”의 의무)",
    description: [
      {
        id: "14-1",
        sub_title: "1. “회원”은 다음 행위를 하여서는 안 됩니다.",
        sub_description: [
          "1) 신청 또는 변경 시 허위내용의 등록\n2) 타인의 정보도용\n3) “회사”가 게시한 정보의 변경\n4) “회사”가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시\n5) “회사”와 기타 제3자의 저작권 등 지적재산권에 대한 침해\n6) “회사” 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위\n7) 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 “서비스”에 공개 또는 게시하는 행위\n8) 회사의 동의 없이 영리를 목적으로 “서비스”를 사용하는 행위\n9) 기타 불법적이거나 부당한 행위",
        ],
      },
      {
        id: "14-2",
        sub_title:
          "2. “회원”은 관계법, 이 약관의 규정, 이용안내 및 “서비스”와 관련하여 공지한 주의사항, “회사”가 통지하는 사항 등을 준수하여야 하며, 기타 “회사”의 업무에 방해되는 행위를 하여서는 안 됩니다. 또한, 회원은 연락처, 전자우편 주소 등 이용계약사항이 변경된 경우에 해당 절차를 거쳐 이를 회사에 즉시 알려야 합니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 15조 (통계정보의 가공과 제공)",
    description: [
      {
        id: "15-1",
        sub_title:
          "“회사”는 “회원”으로부터 수집한 개인 정보 및 서비스 이용기록을 통계학적 방법으로 정리, 분석하여 “통계 자료”로만 가공하며, 가공한 ‘통계 자료’의 저작권 및 소유권, 기타 모든 지적재산권은 모두 ‘회사’가 소유합니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 16조 (통계 분석 자료의 제공)",
    description: [
      {
        id: "16-1",
        sub_title:
          "1. 제 15조 각 호에 해당하는 “통계 자료”는 “회원” 또는 다음 각 호에 해당하는 자에게 제공되어 활용될 수 있습니다.",
        sub_description: [
          "- 요양기관, 대학병원, 병•의원, 약국, 제약사, 학계, 공공기관, 기타 일반 기업",
        ],
      },
      {
        id: "16-2",
        sub_title:
          "“회사”는 가공된 ‘통계 자료’를 사용한 암호화, IP암호화, 서비스 접속 암호화를 통해 보호합니다.",
        sub_description: [],
      },
      {
        id: "16-3",
        sub_title:
          "“회사”는 “통계 자료”를 사업의 목적으로 제 3자에게 제공할 수 있습니다. 단, 인위적 방법을 통한 가공 이전의 정보는 “회원”들의 동의 없이 제 3자에게 제공하지 아니합니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 17조 (정보의 제공 및 광고의 게재)",
    description: [
      {
        id: "17-1",
        sub_title:
          "1. “회사”는 “회원”이 “서비스” 이용 중 필요하다고 인정되는 다양한 정보를 공지사항이나 전자우편 등의 방법으로 “회원”에게 제공할 수 있습니다. 다만, “회원”은 관련법에 따른 거래관련 정보 및 고객문의 등에 대한 답변 등을 제외하고는 언제든지 전자우편에 대해서 수신 거절을 할 수 있습니다.",
        sub_description: [],
      },
      {
        id: "17-2",
        sub_title:
          "2. 제1항의 정보를 전화 및 모사전송기기에 의하여 전송하려고 하는 경우에는 “회원”의 사전 동의를 받아서 전송합니다. 다만, “회원”의 서비스 관련된 내용은 제외됩니다.",
        sub_description: [],
      },
      {
        id: "17-3",
        sub_title:
          "3. “회사”는 “서비스”의 운영과 관련하여 서비스 화면, 홈페이지, 어플리케이션, 전자우편 등에 광고를 게재할 수 있습니다. 광고가 게재된 전자우편을 수신한 “회원”은 수신거절을 “회사”에게 할 수 있습니다.",
        sub_description: [],
      },
      {
        id: "17-4",
        sub_title:
          "4. “회원”은 회사가 제공하는 서비스와 관련하여 게시물 또는 기타 정보를 변경, 수정, 제한하는 등의 조치를 취하지 않습니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 18조 (“게시물”의 저작권)",
    description: [
      {
        id: "18-1",
        sub_title:
          "1. “회원”이 “서비스” 내에 게시한 “게시물”의 저작권은 해당 게시물은 저작권법에 의해 보호를 받습니다. 다만 “회사”가 작성한 게시물에 대한 저작권 등 제 권리는 “회사”에 귀속됩니다.",
        sub_description: [],
      },
      {
        id: "18-2",
        sub_title:
          "2. “회원”이 “서비스” 내에 게시하는 “게시물”은 검색결과 내지 “서비스” 및 관련 프로모션 등에 노출될 수 있으며, 해당 노출을 위해 필요한 범위 내에서는 일부 수정, 복제, 편집되어 게시될 수 있습니다.",
        sub_description: [],
      },
      {
        id: "18-3",
        sub_title:
          "3. “회사”는 제2항 이외의 방법으로 “회원”의 “게시물”을 이용하고자 하는 경우에는 사전에 “회원”에게 고지한다.",
        sub_description: [],
      },
      {
        id: "18-4",
        sub_title:
          "4. “회원”이 “서비스”의 “이용계약”을 “해지”하더라도 “회원”의 명의로 “서비스”에 등록한 “게시물”은 삭제되지 않습니다. “회원”은 “이용계약”을 “해지”한 후, 자신의 “게시물”이 “서비스”에서 이용되는 것을 원하지 않는 경우, “해지” 전에 직접 “게시물”을 삭제하여야 합니다. (단, 제3자가 다시 게시하거나 저장한 게시물은 삭제되지 않을 수 있습니다.)",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 19조 (“게시물”의 관리)",
    description: [
      {
        id: "19-1",
        sub_title:
          "1. “회원”의 “게시물”이 “정보통신망법”,“저작권법” 및 “의료법” 등 관련법에 위반되는 내용을 포함하는 경우, “회사”는 관련법이 정한 절차에 따라 해당 “게시물”의 게시중단 및 삭제 등을 요청할 수 있으며, “회사”는 관련법에 따라 조치를 취하여야 합니다.",
        sub_description: [],
      },
      {
        id: "19-2",
        sub_title:
          "2. “회사”는 전항에 따른 권리자의 요청이 없는 경우라도 아래 규정에서와 같이 권리침해가 인정될 만한 사유가 있거나 기타 회사 정책 및 관련법에 위반되는 경우에는 관련법에 따라 해당 “게시물”에 대해 임시조치 등을 취할 수 있습니다.",
        sub_description: [
          "1) 다른 회원 또는 제 3자에게 심한 모욕을 주거나 명예를 손상시키는 내용인 경우\n2) 공공질서 및 미풍양속에 위반되는 내용을 유포하거나 링크시키는 경우\n3) 불법복제 또는 해킹을 조장하는 내용인 경우\n4) 영리를 목적으로 하는 광고일 경우\n5) 범죄와 결부된다고 객관적으로 인정되는 내용일 경우\n6) 다른 이용자 또는 제 3자의 저작권 등 기타 권리를 침해하는 내용인 경우\n7) 사적인 정치적 판단이나 종교적 견해의 내용으로 회사가 서비스 성격에 부합하지 않는다고 판단하는 경우\n8) 타인의 건강을 위해 하는 검증되지 않은 허위정보로 판단될 경우\n9) 의료인 및 국내 의료기관 간의 비교 광고 성격으로 판단될 경우\n10) 허가 받지 않은 의료행위 또는 의료행위를 위한 선전으로 게시물을 게재할 경우\n11) 회사에서 규정한 게시물 원칙에 어긋나거나, 게시판 성격에 부합하지 않는 경우\n12) 기타 관계법령에 위배된다고 판단되는 경우",
        ],
      },
      {
        id: "19-3",
        sub_title:
          "3. 본 조에 따른 세부절차는 “정보통신망법” 및 “저작권법”이 규정한 범위 내에서 “회사”가 정한 “게시중단 요청 서비스”에 따릅니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 20조 (권리의 귀속)",
    description: [
      {
        id: "20-1",
        sub_title:
          "1. “서비스”에 대한 저작권 및 지적재산권은 “회사”에 귀속됩니다. 단, “회원”의 “게시물” 및 제휴계약에 따라 제공된 저작물 등은 제외합니다.",
        sub_description: [],
      },
      {
        id: "20-2",
        sub_title:
          "2. “회사”는 서비스와 관련하여 “회원”에게 “회사”가 정한 이용조건에 따라 계정, “아이디”, 콘텐츠 등을 이용할 수 있는 이용권만을 부여하며, “회원”은 이를 양도, 판매, 담보제공 등의 처분행위를 할 수 없습니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 21조 (계약해제, 해지 등)",
    description: [
      {
        id: "21-1",
        sub_title:
          "1. “회원”은 언제든지 서비스초기화면의 고객센터 또는 내 정보 관리 메뉴 등을 통하여 이용계약 해지 신청을 할 수 있으며, “회사”는 관련법 등이 정하는 바에 따라 이를 즉시 처리하여야 합니다.",
        sub_description: [],
      },
      {
        id: "21-2",
        sub_title:
          "2. “회원”이 계약을 해지할 경우, 관련법 및 개인정보처리방침에 따라 “회사”가 회원정보를 보유하는 경우를 제외하고는 해지 즉시 “회원”의 모든 데이터는 소멸됩니다. 단, 비식별화 된 데이터는 해지 이후에도 통계의 목적으로 이용할 수 있으며, “회원”이 “서비스”에 등록한 “게시물”은 유지됩니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 22조 (손해배상)",
    description: [
      {
        id: "22-1",
        sub_title:
          "1. 회사와 회원은 서비스 이용과 관련하여 고의 또는 과실로 상대방에게 손해를 끼친 경우에는 이를 배상하여야 합니다.",
        sub_description: [],
      },
      {
        id: "22-2",
        sub_title:
          "2. 단, 회사는 무료로 제공하는 서비스의 이용과 관련하여 개인정보보호정책에서 정하는 내용이나기타 관련 법령에 위반하지 않는 한 손해배상 책임을 지지 않습니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 23조 (이용제한 등)",
    description: [
      {
        id: "23-1",
        sub_title:
          "1. “회사”는 “회원”이 이 약관의 의무를 위반하거나 “서비스”의 정상적인 운영을 방해한 경우, 경고, 일시정지, 영구이용정지 등으로 “서비스” 이용을 단계적으로 제한할 수 있습니다.",
        sub_description: [],
      },
      {
        id: "23-2",
        sub_title:
          "2. “회사”는 전항에도 불구하고, “주민등록법”을 위반한 명의도용 및 결제도용, “저작권법” 및 “컴퓨터 프로그램 보호법”을 위반한 불법프로그램의 제공 및 운영방해, “정보통신망법”을 위반한 불법통신 및 해킹, 악성프로그램의 배포, 접속권한 초과행위 등과 같이 관련법을 위반한 경우에는 즉시 영구이용정지를 할 수 있습니다. 본 항에 따른 영구이용정지 시 “서비스” 이용을 통해 획득한 혜택 등도 모두 소멸되며, “회사”는 이에 대해 별도로 보상하지 않습니다.",
        sub_description: [],
      },
      {
        id: "23-3",
        sub_title:
          "3. “회사”는 본 조의 이용제한 범위 내에서 제한의 조건 및 세부내용은 이용제한정책 및 개별 서비스상의 운영정책에서 정하는 바에 의합니다.",
        sub_description: [],
      },
      {
        id: "23-4",
        sub_title:
          "4. 본 조에 따라 “서비스” 이용을 제한하거나 계약을 해지하는 경우에는 “회사”는 제9조 “회원”에 대한 통지에 따라 통지합니다.",
        sub_description: [],
      },
      {
        id: "23-5",
        sub_title:
          "5. “회원”은 본 조에 따른 이용제한 등에 대해 “회사”가 정한 절차에 따라 이의신청을 할 수 있습니다. 이 때 이의가 정당하다고 “회사”가 인정하는 경우 “회사”는 즉시 “서비스”의 이용을 재개합니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "제 24조 (책임제한)",
    description: [
      {
        id: "24-1",
        sub_title:
          "1. “회사”는 천재지변 또는 이에 준하는 불가항력으로 인하여 “서비스”를 제공할 수 없는 경우에는 “서비스” 제공에 관한 책임이 면제됩니다.",
        sub_description: [],
      },
      {
        id: "24-2",
        sub_title:
          "2. “회사”는 “회원”의 귀책사유로 인한 “서비스” 이용의 장애에 대하여는 책임을 지지 않습니다.",
        sub_description: [],
      },
      {
        id: "24-3",
        sub_title:
          "3. “회사”는 “회원”이 “서비스”와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.",
        sub_description: [],
      },
      {
        id: "24-4",
        sub_title:
          "4. “회사”는 “회원” 간 또는 “회원”과 제3자 상호간에 “서비스”를 매개로 하여 거래 등을 한 경우에는 책임이 면제됩니다.",
        sub_description: [],
      },
      {
        id: "24-5",
        sub_title:
          "5. “회사”는 무료로 제공되는 서비스 이용과 관련하여 관련법에 특별한 규정이 없는 한 책임을 지지 않습니다.",
        sub_description: [],
      },
    ],
  },
  {
    title: "부칙",
    description: [
      {
        id: "25-1",
        sub_title: "이 약관은 2022년 8월 8일부터 적용됩니다.",
        sub_description: [],
      },
      {
        id: "25-2",
        sub_title:
          "회사는 약관을 변경하는 경우에 회원이 그 변경 여부, 변경된 사항의 시행시기와 변경된 내용을 언제든지 쉽게 알 수 있도록 지속적으로 ‘서비스’를 통하여 공개합니다. 이 경우에 변경된 내용은 변경 전과 후를 비교하여 공개합니다.",
        sub_description: [],
      },
    ],
  },
];

export const NECESSARY_AGREEMENTS = [
  {
    text: "헬시어 서비스 이용약관에 동의 합니다",
    url: "https://healthier.notion.site/2c86d82850564d9097d94ad3c334932d",
  },
  {
    text: "개인 정보 처리 방침에 동의 합니다",
    url: "https://healthier.notion.site/dac6c64b62e344f188476541b5ff9377",
  },
] as const;

export const OPTIONAL_AGREEMENTS = [
  {
    text: "이벤트, 혜택 및 마케팅 알림 받기",
    url: "",
  },
] as const;

export const DATA_DELETION_TERM = [
  "회원 탈퇴 시 회사가 보관하고 있는 회원 데이터는 모두 영구적으로 삭제 되며 복구 할 수 없습니다.다만, 관련 볍령에 따라 회사가 보관할 의무가 있는 정보 또는 자료는 일정 기간동안 보관됩니다.",
  "건강챌린지를 통해 획득한 모든 리워드와 티켓은 회원 탈퇴와 동시에 영구적으로 소멸됩니다.",
];

export const SIGNOUT_TERM = [
  "본 약관은 헬시어(이하 “당사”)가  회원(이하 “회원”)의 탈퇴에 관한 모든 조건을 규정한 것입니다. ",
  "회원은 언제든지 서면, 홈페이지 등 당사가 정하는 방법으로 회원 탈퇴를 요청할 수 있으며, 당사는 회원의 요청에 따라 조속히 회원탈퇴에 필요한 제반 절차를 수행합니다. 본 약관은 주식회사 메디올로지(이하 “당사”)가  회원(이하 “회원”)의 탈퇴에 관한 모든 조건을 규정한 것입니다.",
  "회원은 언제든지 서면, 홈페이지 등 당사가 정하는 방법으로 회원 탈퇴를 요청할 수 있으며, 당사는 회원의 요청에 따라 조속히 회원탈퇴에 필요한 제반 절차를 수행합니다. 본 약관은 주식회사 메디올로지(이하 “당사”)가  회원(이하 “회원”)의 탈퇴에 관한 모든 조건을 규정한 것입니다. ",
];

export const SIGNOUT_REASONS = [
  "자주 이용하지 않아서",
  "증상감별이 정확하지 않은 것 같아서",
  "서비스 및 고객지원이 만족스럽지 않아서",
  "광고성 알림이 너무 많이 와서 ",
] as const;

type TTerms = ITerm[];
type TContent = {
  text: string;
  indentation?: number;
  listType?: boolean;
  isTable?: boolean;
  isBackground?: boolean;
};

interface ITerm {
  title: string;
  contents: TContent[];
}

export const PRIVACY_POLICY: TTerms = [
  {
    title: "",
    contents: [
      {
        text: "주식회사 메디올로지(Mediology Co., Ltd.)(이하 ‘회사’ 또는 ‘메디올로지’)는 개인정보 보호법을 준수함에 따라 개인정보 처리방침을 수립하고, 정보주체가 상시 확인할 수 있도록 공개하고 있습니다. 정보주체는 헬시어 웹 및 모바일 어플리케이션(이하 “서비스”) 내에서 본 처리방침을 상시 열람할 수 있습니다.",
      },
    ],
  },
  {
    title: "제 1 조 (개인정보의 처리 목적)",
    contents: [
      {
        text: "회사는 기본적으로 아래 목적 달성을 위해 개인정보를 처리합니다. 단, 법률에서 요구하는 의무 사항을 이행하기 위해서는 정보주체의 동의없이 개인정보를 처리할 수 있습니다.",
      },
      {
        text: "[동의가 필요한 개인정보 처리 목적]",
      },
      {
        text: "가입의사 확인 : 회원가입 등 가입의사 확인 및 계약 체결",
        listType: true,
      },
      {
        text: "회원인증 : 회원의 본인 식별 및 본인인증 수단 제공",
        listType: true,
      },
      {
        text: "실명인증 : 실명제 서비스 제공에 따른 이용자의 본인확인 인증",
        listType: true,
      },
      {
        text: "프로모션운영 : 행사, 설문, 이벤트 등 회원을 대상으로 하는 프로모션의 신청, 접수, 운영",
        listType: true,
      },
      {
        text: "기타 관행상 회사의 서비스 운영에 필요한 활동",
        listType: true,
      },
      {
        text: "",
        isTable: true,
      },
      {
        text: "서비스 이용과정이나 사업처리 과정에서 아래와 같은 정보들이 자동으로 생성되어 수집될 수 있습니다.",
      },
      {
        text: "이용자의 브라우저 종류 및 OS, 방문 기록(IP Address, 접속시간), 쿠키",
        listType: true,
      },
      {
        text: "회사는 홈페이지(www.healthier.kr) 웹문서를 통한 사용자 입력 방법으로 개인정보를 수집하며, 경우에 따라 출력된 형태의 종이문서 혹은 이메일로 일부 정보를 수집할 수도 있습니다.",
      },
      {
        text: "회사는 위 기본 목적과 별개로, 정보주체로부터 별도의 동의를 얻은 경우 해당 목적의 이행을 위해 개인정보를 이용할 수 있습니다.",
      },
      {
        text: "신규 서비스에 대한 소식 전달",
        listType: true,
      },
      {
        text: "상품 권유 혹은 이벤트 참여 제안",
        listType: true,
      },
      {
        text: "광고성 정보의 송ㆍ수신(이메일, 문자, 앱푸시 등)",
        listType: true,
      },
      {
        text: "관행상 마케팅 행위로 간주되는 활동",
        listType: true,
      },
      {
        text: "위의 개인정보 수집 이용에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우 원활한 서비스 이용에 제한을 받을 수 있습니다.",
      },
      {
        text: "회사는 위 기본 목적과 별개로, 정보주체로부터 별도의 동의를 얻은 경우 해당 목적의 이행을 위해 개인정보를 이용할 수 있습니다.",
      },
      {
        text: "[동의가 필요하지 않은 개인정보 처리 목적]",
      },
      {
        text: "계약의 체결 및 이행 : 서비스 약관 체결 및 부가 서비스 가입 시 약관에 따른 회사의 의무 이행",
        listType: true,
      },
      {
        text: "고객관리 : 서비스 운영과 관련한 문의의 신청, 접수, 답변 등 의사소통 진행",
        listType: true,
      },
      {
        text: "서비스운영 : 서비스 부정이용 방지를 위한 조치, 서비스의 개선, 질적 향상을 위한 분석, 행태정보를 이용한 개인 맞춤형 서비스 설계 및 제공, 제휴 서비스 연계, 위탁 업무의 수행",
        listType: true,
      },
      {
        text: "위의 개인정보 수집 이용에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우 원활한 서비스 이용에 제한을 받을 수 있습니다.",
      },
    ],
  },
  {
    title: "제 2 조 (처리하는 개인정보의 항목)",
    contents: [
      {
        text: "1. 회사는 제1조에 명시한 목적 달성 및 서비스 이용약관에 명시한 회사의 의무 사항을 이행하기 위해 개인정보를 처리하며 각 서비스 제공 절차별 처리하는 개인정보의 항목과 그 이용 및 보유기간은 아래에 명시하는 바와 같습니다.",
      },
      {
        text: "가) 헬시어 앱, 웹앱(app.healthier.kr)",
        indentation: 1,
      },
      {
        text: "ㄱ) 회원정보 : 탈퇴 시까지",
        indentation: 2,
      },
      {
        text: "카카오 계정으로 간편가입 : [필수] 카카오계정(이메일주소, 전화번호), 카카오프로필(닉네임, 사진) / [선택] 성별, 배송지정보(수령인의 이름, 주소, 전화번호), 연령대, 출생년도, 생일",
        indentation: 3,
        listType: true,
      },
      {
        text: "애플 계정으로 간편가입 : [필수] 애플계정(이메일주소)",
        indentation: 3,
        listType: true,
      },
      {
        text: "회원정보 수정 : [선택] 주소",
        indentation: 3,
        listType: true,
      },
      {
        text: "ㄴ) 본인확인정보 : 탈퇴 시까지 통신사 인증으로 본인확인",
        indentation: 2,
      },
      {
        text: "통신사 인증으로 본인확인 : [필수] 본인확인인증식별자(CI, DI), 생년월일, 성별, 이름, 휴대폰번호",
        indentation: 3,
        listType: true,
      },
      {
        text: "회사는 본인확인업무를 **“NICE 평가정보”**에 위탁하여 개인정보를 제공받습니다.",
        indentation: 4,
        listType: true,
      },
      {
        text: "ㄷ) 건강검진정보 : 탈퇴 시까지",
        indentation: 2,
      },
      {
        text: "건강검진기록 불러오기 : [필수] 본인확인인증",
        indentation: 3,
        listType: true,
      },
      {
        text: "회사는 정보주체의 요구에 따라 **“국민건강보험공단”**으로부터 건강검진기록을 제공받습니다.",
        indentation: 4,
        listType: true,
      },
      {
        text: "나) 헬시어 비즈니스 웹(www.healthier.kr)",
        indentation: 1,
      },
      {
        text: "수집정보 : 3년",
        indentation: 2,
      },
      {
        text: "서비스 신청/제휴 문의 : [필수] 성명(이름), 연락처(전화번호), 이메일(이메일주소), [선택] 기관/단체",
        indentation: 3,
        listType: true,
      },
      {
        text: "다) 헬시어 병원용 서비스",
        indentation: 1,
      },
      {
        text: "수집정보 : 서비스 종료일까지",
        indentation: 2,
      },
      {
        text: "홈페이지 회원가입 : [필수] 로그인정보(아이디, 비밀번호), 관리자명(이름), 연락처(전화번호), 이메일(이메일주소), 가입병원(병원명)",
        indentation: 3,
        listType: true,
      },
      {
        text: "2. 회사는 제3자로부터 개인정보를 제공받을 수 있습니다. 이 때, 제공에 대한 동의 책임은 제공자에게 있습니다. 헬시어는 제휴처 혹은 업무 위탁 관계자 외의 제3자로부터 정보주체의 동의와 무관하게 제공받은 개인정보에 대해서는 그 수령 사실을 알릴 것입니다.",
      },
      {
        text: "3. 회사의 서버에 설치된 자동 수집 장치는 회원이 서비스를 이용하는 과정에서 통신정보(MAC address, IP address), 기기정보(모델명, 사양, 단말기고유식별자, 유저고유식별자, 광고식별자, 연계식별자), OS정보(OS명, 버전)를 자동으로 수집할 수 있습니다. 해당 정보는 서비스의 원활한 운영과 제공을 위해 회원의 개인정보와 결합하여 이용됩니다.",
      },
    ],
  },
  {
    title: "제 3 조 (개인정보의 처리 및 보유기간)",
    contents: [
      {
        text: "1. 회사는 이용자로부터 동의받아 처리하는 개인정보는 “개인정보 수집 및 이용 동의” 시 안내한 기간에 따릅니다. 그러나, 제3자로부터 제공받거나 위탁받은 개인정보는 제3자가 고지한 기간에 따라 보유합니다.",
      },
      {
        text: "2. 회사가 직접 수집하여 처리하는 개인정보의 보유기간은 본 처리방침의 “제2조 처리하는 개인정보의 항목”을 확인하여 주시기 바랍니다.",
      },
      {
        text: "3. 개인정보의 보유기간내 개인정보의 이용 목적이 달성되는 경우에는 회사는 지체없이 해당 개인정보를 파기합니다. 단, 아래에서 안내하는 바에 따라 다른 목적의 이행을 위해서 동의없이 보존될 수 있습니다. 이 경우 해당 정보는 분리된 환경에 보관하며 해당 목적의 이행에 한하여 처리 됩니다.",
      },
      {
        text: "가) 법령에서 정한바에 따라 의무로 보존하여야 하는 경우",
        indentation: 1,
      },
      {
        text: "ㄱ) 전자상거래 등에서의 소비자보호에 관한 법률",
        indentation: 2,
      },
      {
        text: "표시/광고에 관한 기록 : 6개월",
        indentation: 3,
        listType: true,
      },
      {
        text: "계약 또는 청약철회 등에 관한 기록 : 5년",
        indentation: 3,
        listType: true,
      },
      {
        text: "대금결제 및 재화 등의 공급에 관한 기록 : 5년",
        indentation: 3,
        listType: true,
      },
      {
        text: "소비자의 불만 또는 분쟁 처리에 관한 기록 : 5년",
        indentation: 3,
        listType: true,
      },
      {
        text: "ㄴ) 국세기본법 및 지방세기본법",
        indentation: 2,
      },
      {
        text: "장부 및 증거서류 : 5년",
        indentation: 3,
        listType: true,
      },
      {
        text: "ㄷ) 위치정보의 보호 및 이용 등에 관한 법률",
        indentation: 2,
      },
      {
        text: "개인위치정보에 관한 기록 : 6개월",
        indentation: 3,
        listType: true,
      },
      {
        text: "ㄹ) 통신비밀보호법",
        indentation: 2,
      },
      {
        text: "서비스 이용 기록 : 6개월",
        indentation: 3,
        listType: true,
      },
      {
        text: "나) 형의 기소와 재판에 필요한 정보로써 법원이 요구하는 경우",
        indentation: 1,
      },
      {
        text: "다) 계약의 미 이행, 채무의 정산을 위한 증거로 필요한 경우",
        indentation: 1,
      },
    ],
  },
  {
    title: "제 4 조 (개인정보의 제3자 제공에 관한 사항)",
    contents: [
      {
        text: "회사는 기본적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다. 그러나, 아래에서 안내하는 내용에 따라 개인정보를 제3자에게 제공할 수 있습니다.",
      },
      {
        text: "1. 개인정보 제3자 제공에 대하여 정보주체가 동의한 경우",
      },
      {
        text: "2. 서비스 제공에 따른 요금 정산을 위하여 필요한 경우",
      },
      {
        text: "3. 회사가 제공하는 서비스를 통하여 거래가 성사된 경우, 거래 당사자간의 원활한 의사소통을 위하여 관련된 정보를 필요한 범위 내에서 거래 당사자에게 제공하는 경우",
      },
      {
        text: "4. 통계작성, 학술연구나 시장조사를 위해 특정 개인을 식별할 수 없는 형태로 가명처리하여 제공하는 경우",
      },
      {
        text: "5. 법령에서 정한바에 따라 의무로 제공해야 하는 경우",
      },
      {
        text: "6. 재난, 감염병, 신체상 급박한 위험, 정보주체 혹은 제3자의 재산 피해 등 개인정보 보호위원회에서 긴급한 경우로 정한 상황에 대해 관계자의 개인정보 열람 혹은 제공이 요구되는 경우",
      },
    ],
  },
  {
    title: "제 5 조 (개인정보처리의 위탁에 관한 사항)",
    contents: [
      {
        text: "회사는 양질의 서비스를 제공하기 위해 개인정보 처리를 제3자에게 위탁하여 처리할 수 있습니다. 위탁업무를 하는 경우에는 해당 내용을 이용자에게 알리고 동의를 받으며, 어느 하나의 사항이 변경된 경우에도 동일합니다.",
      },
      {
        text: "1. 회사는 정보통신서비스의 제공에 관한 계약을 이행하고 이용자의 편의 증진 등을 위하여 필요한 경우로서 본 개인정보처리방침 인터넷 홈페이지의 첫 화면 또는 첫 화면과 연결된 페이지를 통하여 공개하는 등 정보통신망법에서 정한 방법으로 공개함으로써 이용자께 고지 또는 동의 절차 없이 개인정보 수탁업체에게 처리를 위탁할 수 있습니다.",
      },
      {
        text: "2. 회사는 위탁계약 체결 시 위탁업무 수행목적 외 개인정보 처리금지, 기술적ㆍ관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리ㆍ감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는 지를 감독하고 있습니다.",
      },
      {
        text: "3. 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체 없이 본 개인정보 처리방침을 통하여 공개합니다.",
      },
    ],
  },
  {
    title: "제 6 조 (국외의 제3자에게 제공하는 개인정보에 관한 사항)",
    contents: [
      {
        text: "회사는 개인정보를 국외의 제3자에게 제공하지 않습니다. 국외의 제3자에게 제공하거나 위탁하는 경우 관련 사실을 개인정보 처리방침에 명시하겠습니다.",
      },
    ],
  },
  {
    title: "제 7 조 (개인정보의 파기절차 및 파기방법)",
    contents: [
      {
        text: "1. 회사는 개인정보 보유기간의 경과, 이용목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 정보주체의 개인정보를 파기합니다. 개인정보는 저장 매체에 따라 복원이 불가능한 방법으로 파기합니다.",
      },
      {
        text: "가) 전자적 파일 형태로 기록된 개인정보 : 기록을 재생할 수 없는 기술적 방법을 적용하여 파기합니다.",
        indentation: 1,
      },
      {
        text: "나) 종이 문서에 기록된 개인정보 : 파쇄기를 사용하여 파쇄합니다.",
        indentation: 1,
      },
      {
        text: "2. 처리방침 “제3조 개인정보 처리 및 보유기간” 제3항에 따라 개인정보를 파기하지 않고 보존하여야 하는 경우에는 해당 개인정보를 일반 업무 용도로 접근하지 못하도록 분리보관 조치하고, 접근이 가능한 관리자를 별도 지정하여 관리할 것입니다.",
      },
      {
        text: "가) 전자적 파일 형태로 기록된 개인정보 : 물리적 혹은 논리적으로 분리된 공간에 이관하여 보존합니다. 논리적으로 분리된 경우 접근통제 조치를 통해 무분별한 접근을 엄격히 제한합니다.",
        indentation: 1,
      },
      {
        text: "나) 종이 문서에 기록된 개인정보 : 잠금장치가 있는 보관함에 비치하여 보존하며, 해당 보관함에 접근하는 인원에 대한 모니터링 조치 등 통제 정책을 적용합니다.",
        indentation: 1,
      },
    ],
  },
  {
    title:
      "제 8 조 (개인정보를 자동으로 수집하는 장치의 설치ㆍ운영 그 거부에 관한 사항)",
    contents: [
      {
        text: "1. 회사의 서버에 설치된 자동 수집 장치는 회원이 서비스를 이용하는 과정에서 통신정보(MAC address, IP address), 기기정보(모델명, 사양, 단말기고유식별자, 유저고유식별자, 광고식별자, 연계식별자), OS정보(OS명, 버전)를 자동으로 수집할 수 있습니다. 해당 정보는 서비스의 원활한 운영과 제공을 위해 회원의 개인정보와 결합하여 이용됩니다.",
      },
      {
        text: "2. 회사는 방문자의 브라우저를 통하여 쿠키(cookie)를 생성하고 전송합니다. 쿠키는 사이트를 방문한 이용자의 기기에 저장되는 작은 규모의 정보로써 사이트 정보를 저장하고 사이트 내 활동을 추적할 수 있습니다. 회사는 다음 목적을 위해 쿠키를 이용합니다.",
      },
      {
        text: "가) 악의적인 접근 및 이용의 방지를 위한 보안상 목적으로 이용",
        indentation: 1,
      },
      {
        text: "나) 이용자의 사용 환경 및 성능 유지, 사이트간 연결성 확보를 통한 양질의 서비스 제공 목적으로 이용",
        indentation: 1,
      },
      {
        indentation: 1,
        text: "다) 트래픽, 유입, 방문시간, 사이트내 활동 분석을 통한 사이트의 운영 개선을 위한 목적으로 이용",
      },
      {
        indentation: 1,
        text: "라) 방문자에 대한 선택적 광고 및 추천 등 이용 데이터를 기반으로 하는 맞춤형 마케팅 목적으로 이용",
      },
      {
        indentation: 1,
        text: "※ 쿠키(cookie)는 웹 서비스 제공자의 서버가 이용자의 컴퓨터로 전송하는 소량의 정보입니다.",
      },
      {
        text: "3. 회사는 방문자에 대해 세션(session)을 생성합니다. 세션은 사이트를 방문한 이용자를 서버에 등록하여 이용 종료 시까지 사이트 내 이용 자격 상태를 유지하는데 이용합니다.",
      },
      {
        text: "4. 회사는 일반적으로 쿠키나 세션을 통해서는 별도로 개인정보를 수집하거나 활용하지 않습니다. 단, 보안상 악의적인 접근에 대한 보안상 대응 과정에서 다른 회원정보와 결합하여 차단 및 대응 조치를 행할 수 있습니다.",
      },
      {
        text: "5. 회원 혹은 방문자는 회사의 쿠키 운영 정책에 반대하여 웹 브라우저 상단의 설정에서 회사의 쿠키 운영에 대한 허용, 조건부 허용, 차단 상태를 결정할 수 있습니다.",
      },
      {
        text: "[Edge : 설정 - 쿠키 및 사이트 권한 - 쿠키 및 사이트 데이터 관리 및 삭제]\n[Chrome : 설정 - 고급 - 콘텐츠 설정 - 쿠키]",
      },
    ],
  },
  {
    title:
      "제 9 조 (정보주체와 법정대리인의 권리ㆍ의무 및 그 행사 방법에 관한 사항)",
    contents: [
      {
        text: "1. 회사는 만 14세 미만의 아동으로부터 개인정보 수집ㆍ이용ㆍ제공 등의 동의를 받는 경우에는 그 법정대리인의 동의를 별도로 구할 것이며, 그 때 아동에게 법정대리인의 성명과 연락 가능한 최소한의 정보를 요구할 수 있습니다. 아동으로부터 법정대리인의 개인정보를 확보할 수 없거나, 아동을 대상으로 제공하는 서비스가 아닌 경우에는 아동으로부터 개인정보를 수집하지 않습니다.",
      },
      {
        text: "2. 회사는 “1.”에 의하여 법정대리인의 동의를 얻은 경우 해당 정보를 아동의 회원정보에 포함하여 저장합니다. 등록된 법정대리인은 아동을 대신하여 개인정보 처리에 대해 회사에 권리행사할 수 있습니다. 아동의 회원정보에 등록되지 않은 법정대리인의 경우, 회사는 “가족관계증명서”등 아동의 법정대리인임을 확인할 수 있는 서류를 추가로 요구할 수 있습니다.",
      },
      {
        text: "3. 정보주체 및 법정대리인은 언제든지 개인정보의 처리를 결정할 주체로써 아래 권리를 행사할 수 있습니다. 회사는 정보주체 및 법정대리인의 권리행사에 대해서 지체없이 응대할 것이며, 응대가 지연되는 경우 그 사유를 정보주체가 확인할 수 있도록 사전에 고지하거나, 응대 지연에 대한 내용을 회신하고 가능한 빠른 시일 내에 조치할 것입니다.",
      },
      {
        text: "가) 개인정보 처리에 동의하거나 거부할 권리\n나) 개인정보와 그 이용 내역에 대해 열람을 요구할 권리\n다) 개인정보에 대해 수정(정정)ㆍ삭제를 요구할 권리\n라) 회사의 개인정보 처리에 대해 처리정지를 요구할 권리\n마) 개인정보 처리에 대한 동의를 철회할 권리",
        indentation: 1,
      },
      {
        text: "4. 회사는 기본적으로 정보주체 및 법정대리인의 권리행사에 응대할 채널을 운영하고 있으나, 요구에 대한 빠른 대응을 위해 시스템 내에서 관련 메뉴나 기능을 제공하고 있습니다. 해당 기능과 접근 절차에 대한 문서는 여기를 눌러 확인하여 주시기 바랍니다.",
      },
      {
        text: "5. 회사는 정보주체 및 법정대리인의 권리행사에 대하여 적극 응대하겠습니다. 다만, 해당 요청이 법률에서 요구하는 의무 사항과 경합하는 경우, 회사는 법률에서 요구하는 사항을 우선으로 하여 정보주체 및 법정대리인의 요구 사항에 거부할 수 있으며, 그 경우에는 거부 사유를 회신하겠습니다.",
      },
      {
        text: "6. 정보주체 및 법정대리인은 권리행사에 대한 회사의 응대나 회사의 개인정보 처리 정책의 결정에 대하여 이의제기할 수 있습니다. 이의제기 시 처리방침 제14조에 따은 개인정보 보호책임자 혹은 제16조에 따른 권익침해 구제기관에 문의하여 주시기 바랍니다.",
      },
      {
        text: "7. 정보주체는 회사에 가장 최신의 정보이면서 정확한 정보를 지속적으로 전달하거나 유지하여야 합니다. 회사의 관리 절차를 우회하거나, 잘못된 정보를 기재하였거나 타인의 정보를 도용하여 발생한 모든일에 대한 책임은 정보주체에게 있습니다. 회사는 개인정보 도용 신고가 접수되는 경우 해당 계정에 대해 즉시탈퇴 등 도용 피해자를 위해 강제 조치를 할 수 있습니다.",
      },
      {
        text: "8. 정보주체는 회원 인증 수단에 대한 정보를 타인에게 공유하여서는 아니되며, 안전한 관리를 위해 비밀번호의 작성 규칙을 준수할 것을 권고합니다. 개인의 부주의로 유출 혹은 침해 피해를 입은 개인정보에 대해서 회사는 책임지지 않습니다.",
      },
    ],
  },
  {
    title: "제 10 조 (개인위치정보의 처리)",
    contents: [
      {
        text: "회사는 위치기반서비스사업을 영위하며, 위치정보의 보호 및 이용 등에 관한 법률(이하 ‘위치정 보법’)에 따라 다음과 같이 개인위치정보를 처리합니다.",
      },
      {
        text: "1. 개인위치정보의 처리목적 및 보유기간",
      },
      {
        text: "가) 병/의원 및 약국찾기 기능을 목적으로 개인위치정보를 처리하고 있으며 해당 정보는 서비스 제공 이후 지체없이 파기됩니다.",
        indentation: 1,
      },
      {
        text: "나)회사는 위치기반서비스에서 개인위치정보를 일회성 또는 임시로 사용 후 지체없이 파기합니다.",
        indentation: 1,
      },
      {
        text: "2. 개인위치정보 수집ㆍ이용ㆍ제공사실 확인자료의 보유근거 및 보유기간",
      },
      {
        text: "위치정보법 제16조 2항에 근거하여 이용자의 위치정보 수집ㆍ이용ㆍ제공사실 확인자료를 위치정보시스템에 자동으로 기록하며 6개월 이상 보관합니다.",
        indentation: 1,
      },
      {
        text: "3. 개인위치정보의 파기 절차 및 방법",
      },
      {
        text: "개인위치정보의 처리목적이 달성된 경우, 개인위치정보를 재생이 불가능한 방법으로 안전하게 파기합니다. 전자적 파일 형태는 복구 및 재생이 불가능한 기술적인 방법으로 파기하며, 출력물 등은 분쇄하거나 소각하는 방식으로 파기합니다.",
        indentation: 1,
      },
      {
        text: "4. 개인위치정보의 제3자 제공 및 통보에 관한 사항",
      },
      {
        text: "이용자의 동의 없이 개인위치정보를 제3자에게 제공하지 아니합니다. 단 관계법령에 의한 수사상의 목적으로 관계기관으로부터 요구받은 경우나 방송통신심의위원회의 요청이 있는 경우 또는 회사가 정한 기간 동안 이용요금을 체납하여 이용자의 동의를 얻어 신용정보사업자 또는 신용정보집중기관에 제공하는 경우에는 예외사항이 인정됩니다.",
        indentation: 1,
      },
      {
        text: "5. 8세 이하의 등의 보호의무자 권리·의무 및 그 행사방법",
      },
      {
        text: "가) 아래의 경우에 해당하는 자(이하 ‘8세 이하의 아동’등이라 한다)의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체보호를 위하여 개인위치정보의 이용 또는 제공에 동의하는 경우 본인의 동의가 있는 것으로 봅니다.",
        indentation: 1,
      },
      {
        text: "ㄱ) 8세 이하의 아동",
        indentation: 2,
      },
      {
        text: "ㄴ) 금치산자",
        indentation: 2,
      },
      {
        text: "ㄷ) 장애인복지법 제2조 2항 2호의 규정에 의한 정신적 장애를 가진 자로서 장애인고용촉진 및 직업재활법 제2조 2호의 규정에 의한 중증장애인에 해당하는 자 (장애인복지법 제29조의 규정에 의하여 장애인 등록을 한 자에 한한다)",
        indentation: 2,
      },
      {
        text: "나) 8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의 이용 또는 제공에 동의를 하고자 하는 보호의무자는 동의서에 보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다.",
        indentation: 1,
      },
      {
        text: "다) 보호의무자는 8세 이하의 아동 등의 개인위치정보 이용 또는 제공에 동의하는 경우 개인위치정보주체 권리의 전부를 행사할 수 있습니다.",
        indentation: 1,
      },
      {
        text: "6. 위치정보 관리책임자의 정보",
      },
      {
        text: "위치정보 관리책임자는 개인정보 보호책임자가 겸직으로 수행하고 있습니다.",
        indentation: 1,
      },
    ],
  },
  {
    title: "제 11 조 (개인정보의 안전성 확보조치)",
    contents: [
      {
        text: "1. 회사는 이용자의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적ㆍ관리적ㆍ물리적 조치를 취하고 있습니다.",
      },
      {
        text: "가) 안전성 확보를 위한 관리적 조치",
        indentation: 1,
      },
      {
        text: "ㄱ) 개인정보 내부관리계획의 수립 및 이행\nㄴ) 개인정보취급자 지정 최소화\nㄷ) 개인정보보호 인식 제고를 위한 교육 실시\nㄹ) 비밀유지 계약 등 임직원 책임성 부여",
        indentation: 2,
      },
      {
        text: "나) 안전성 확보를 위한 기술적 조치",
        indentation: 1,
      },
      {
        text: "ㄱ) 개인정보 데이터에 대한 접근통제 조치\nㄴ) 업무별 권한 분리 및 권한 차등 부여\nㄷ) 중요 개인정보 암호화 조치",
        indentation: 2,
      },
      {
        text: "다) 안전성 확보를 위한 물리적 조치",
        indentation: 1,
      },
      {
        text: "ㄱ) 사업장 출입통제 장치 설치 및 인가자 출입\nㄴ) 중요한 문서는 잠금 장치가 설치된 보관함에 보관",
        indentation: 2,
      },
    ],
  },
  {
    title: "제 12 조 (개인정보 보호책임자에 관한 사항)",
    contents: [
      {
        text: "1. 회사는 개인정보 처리 및 보호와 관련한 업무의 총괄 책임자를 지정하고, 개인정보 처리와 관련하여 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.",
      },
      {
        text: "개인정보 보호책임자: 정설아\n담당부서/직위: CEO\n전화번호: 0504-0803-7188\n이메일 주소: ceo@mediology.ai",
        isBackground: true,
      },
      {
        text: "2. 이용자는 회사의 서비스를 이용하면서 발생한 모든 개인정보보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 혹은 제15조 개인정보 열람청구를 접수ㆍ처리하는 부서로 문의하실 수 있습니다.",
      },
    ],
  },
  {
    title: "제 13 조 (개인정보의 열람청구를 접수ㆍ처리하는 부서)",
    contents: [
      {
        text: "회사는 정보주체와의 원활한 의사소통을 위해 개인정보 열람청구를 접수하는 고객센터를 운영하고 있으며 연락처는 아래와 같습니다.",
      },
      {
        text: "1. 고객센터(전화) : 0504-0803-7188\n2. 메일 : ceo@mediology.ai\n\n※ 고객센터 운영시간은 평일 오전 10시부터 오후 7시(10:00~19:00)까지 운영하고 있으며 토요일, 공휴일은 운영하지 않습니다.",
        isBackground: true,
      },
    ],
  },
  {
    title: "제 14 조 (권익침해 구제방법)",
    contents: [
      {
        text: "개인정보에 관한 권익을 침해 당한 경우, 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의 신고, 상담에 대해서는 아래의 기관에 문의하시기 바랍니다.",
      },
      {
        text: "1. 개인정보분쟁조정위원회 / 전화번호(☎️) : (국번없이) 1833-6972 / URL : www.kopico.go.kr\n2. 개인정보침해신고센터 / 전화번호(☎️) : (국번없이) 118 / URL : privacy.kisa.or.kr\n3. 대검찰청 / 전화번호(☎️) : (국번없이) 1301 / URL : www.spo.go.kr\n4. 경찰청 사이버범죄 신고시스템 / 전화번호(☎️) : (국번없이) 182 / URL : ecrm.police.go.kr",
        isBackground: true,
      },
    ],
  },
  {
    title: "제 15 조 (개인정보 처리방침의 변경에 관한 사항)",
    contents: [
      {
        text: "1. 개인정보 처리방침의 내용을 변경할 경우에는 개정일로부터 7일 전 운영하는 앱 혹은 대표 홈페이지를 통하여 개정 사실과 변경할 내용을 미리 고지하겠습니다.",
      },
      {
        text: "가) 공지일자: 2025년 02월 06일\n나) 시행일자: 2025년 02월 07일",
        indentation: 1,
      },
      {
        text: "2. 정보주체는 아래 링크를 통해 개정 이전의 개인정보 처리방침을 확인하실 수 있습니다.",
      },
    ],
  },
];
export const TERM_OF_USE: TTerms = [
  {
    title: "제 1 조 (목적)",
    contents: [
      {
        text: '이 약관은 주식회사 메디올로지(Mediology Co., Ltd.)(이하 ‘회사’ 또는 ‘메디올로지’)가 제공하는 헬시어 서비스(이하 "서비스" 및 "헬시어"이라 함)의 이용과 관련하여 "회사"와 "회원"과의 권리, 의무 및 책임사항, 이용조건 및 절차 등 기본적인 사항을 규정함을 목적으로 합니다.',
      },
    ],
  },
  {
    title: "제 2 조 (용어의 정의)",
    contents: [
      {
        text: "이 약관에서 사용하는 용어의 정의는 다음과 같습니다.",
      },
      {
        text: '1. "회원"이라 함은 "회사"의 "서비스"에 접속하여 이 약관에 따라 "회사"와 "이용계약"을 체결하고 "회사"가 제공하는 "서비스"를 이용하는 고객을 말합니다.',
      },
      {
        text: '2. "아이디(ID)"라 함은 "회원"의 식별과 "서비스" 이용을 위하여 "회원"이 정하고 "회사"가 승인하는 문자와 숫자의 조합을 의미합니다.',
      },
      {
        text: '3. "비밀번호"라 함은 "회원"이 부여 받은 "아이디"와 일치되는 "회원"임을 확인하고 비밀보호를 위해 "회원" 자신이 정한 문자 또는 숫자의 조합을 의미합니다.',
      },
      {
        text: '4. "이용계약"이라 함은 이 약관을 포함하여 서비스 이용과 관련하여 "회사"와 "회원 간에 체결하는 모든 계약을 말합니다.',
      },
      {
        text: '5. "해지"라 함은 "회사" 또는 "회원"이 "이용계약"을 해약하는 것을 말합니다.',
      },
      {
        text: '6. "이용자"라 함은 "회사"에서 제공하는 "서비스" 또는 관련 제반 서비스를 이용하는 "회원"과 "비회원"을 말합니다.',
      },
      {
        text: "이 약관에서 사용하는 용어 중 제 2조에서 정하지 아니한 것은 관계 법령 및 서비스 별 안내에서 정하는 바에 따르며, 그 외에는 일반 관례에 따릅니다.",
      },
    ],
  },
  {
    title: "제 3 조 (약관의 게시와 개정)",
    contents: [
      {
        text: '1. "회사"는 이 약관의 내용을 "회원" 또는 개인위치정보주체가 쉽게 알 수 있도록 서비스 초기화면 및 더보기 > 환경설정 > 약관 및 개인정보 처리 동의에 게시합니다.',
      },
      {
        text: '2. "회사"는 약관의 규제에 관한 법률, 개인정보보호법, "정보통신망이용촉진 및 정보보호 등에 관한 법률(이하 "정보통신망법")" 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.',
      },
      {
        text: '3. "회사"가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 제1항의 방식에 따라 그 개정약관의 적용일자 7일 전부터 적용일자 전 일까지 공지합니다. 다만, "회원"에게 불리한 약관의 개정의 경우에는 그 적용일자 30일 전부터 공지하고, 공지 외에 일정기간 서비스 내 로그인 시 동의창 등의 전자적 수단을 통해 따로 명확히 통지하도록 합니다.',
      },
      {
        text: '4. "회사"가 전항에 따라 개정약관을 공지 또는 통지 하면서 "회원"에게 7일 또는 30일 기간 내에 의사표시를 하지 않으면 의사표시가 표명된 것으로 본다는 뜻을 명확하게 공지 또는 통지 하였음에도 "회원"이 명시적으로 거부의 의사표시를 하지 아니하고 서비스를 계속 사용할 경우 "회원"이 개정약관에 동의한 것으로 봅니다.',
      },
      {
        text: '5. "회원"이 개정약관의 적용에 동의하지 않는 경우 "회사"는 개정 약관의 내용을 적용할 수 없으며, 이 경우 "회원"은 "이용계약"을 해지할 수 있습니다. 또한, 기존 약관을 적용할 수 없는 특별한 사정이 있는 경우에 "회사"는 "이용계약"을 해지할 수 있습니다.',
      },
    ],
  },
  {
    title: "제 4 조 (약관의 해석)",
    contents: [
      {
        text: '1. "회사"는 개별 서비스에 대해서는 별도의 이용약관 및 정책(이하 서비스 별 이용약관 또는 정책)을 둘 수 있으며, 해당 내용이 이 약관과 상충할 경우에는 "서비스 별 이용약관 또는 정책"을 우선하여 적용합니다.',
      },
      {
        text: "2. 이 약관에서 정하지 아니한 사항이나 해석에 대해서는 관계법령 또는 상관례에 따릅니다.",
      },
    ],
  },
  {
    title: '제 5 조 ("이용계약" 체결)',
    contents: [
      {
        text: '1. "이용계약"은 "회원"이 되고자 하는 자(이하 가입신청자)가 약관의 내용에 대하여 동의를 한 다음 회원가입신청을 하고 "회사"가 이러한 신청에 대하여 승낙함으로써 체결됩니다. 필요한 경우 회사는 본인확인기관을통한 실명확인 및 본인인증을 요청할 수 있습니다.',
      },
      {
        text: "2. 가입신청자는 가입신청 시 진실한 정보를 기재하여야 하며, 허위의 정보를 기재함으로 인한 불이익 및 법적 책임은 가입신청자에게 있습니다.",
      },
      {
        text: '3. "회사"는 "가입신청자"의 신청에 대하여 "서비스" 이용을 승낙함을 원칙으로 합니다. 다만, "회사"는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 "이용계약"을 해지할 수 있습니다.',
      },
      {
        text: '가) 가입신청자가 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우, 단 "회사"의 회원 재가입 승낙을 얻는 경우에는 예외로 함.',
        indentation: 1,
      },
      {
        text: "나) 타인의 명의를 이용한 경우",
        indentation: 1,
      },
      {
        text: '다) 허위의 정보를 기재하거나, "회사"가 제시하는 내용을 기재하지 않은 경우',
        indentation: 1,
      },
      {
        text: '라) "회원"의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우',
        indentation: 1,
      },
      {
        text: "마) 사회의 안녕질서 또는 미풍양속을 저해하거나, 저해할 목적으로 신청한 경우",
        indentation: 1,
      },
      {
        text: '4. "회사"는 서비스 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.',
      },
      {
        text: '5. 제 2항과 제 3항에 따라 회원가입신청의 승낙을 하지 아니하거나 유보한 경우, "회사"는 원칙적으로 이를 가입신청자에게 알리도록 합니다.',
      },
      {
        text: '6. "이용계약"의 성립 시기는 "회사"가 가입완료를 신청절차 상에서 표시한 시점으로 합니다.',
      },
      {
        text: '7. "회사"는 "가입신청자"가 관계 법령에서 규정하는 미성년자일 경우에 서비스별 안내에서 정하는 바에 따라 승낙을 보류할 수 있습니다.',
      },
      {
        text: '8. "회사"는 "회원"에 대해 "회사" 정책에 따라 등급별로 구분하여 이용시간, 이용횟수, 서비스 메뉴 등을 세분하여 이용에 차등을 둘 수 있습니다.',
      },
      {
        text: '9. "회사"는 "회원"에 대하여 "청소년보호법" 등에 따른 등급 및 연령 준수를 위해 이용제한이나 등급별 제한을 할 수 있습니다.',
      },
    ],
  },
  {
    title: "제 6 조 (서비스의 내용)",
    contents: [
      {
        text: "회사가 제공하는 서비스는 아래와 같습니다.",
      },
      {
        text: "1. 사용자 위치를 기반으로 한 병원/약국 찾기 제공",
      },
      {
        text: "2. 증상감별 서비스 제공",
      },
      {
        text: "3. 자체/제휴 제작 건강 콘텐츠 제공",
      },
      {
        text: "4. 건강챌린지 서비스 제공",
      },
    ],
  },
  {
    title: "제 7 조 (서비스 이용요금)",
    contents: [
      {
        text: '1. "회사"가 제공하는 서비스는 기본적으로 무료입니다.',
      },
      {
        text: '2. "회원"의 개인정보도용 등 법적분쟁으로 인한 정보 요구는 법률이 정한 경우 외에는 거절될 수 있습니다.',
      },
      {
        text: "3. 무선 서비스 이용 시 발생하는 데이터 통신료는 별도이며 가입한 각 이동통신사의 정책에 따릅니다.",
      },
    ],
  },
  {
    title: '제 8 조 ("회원" 정보의 변경)',
    contents: [
      {
        text: '1. "회원"은 개인정보관리화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다.',
      },
      {
        text: '2. "회원"은 회원가입신청 시 기재한 사항이 변경 되었을 경우 온라인으로 수정을 하거나 전자우편 등 기타 방법으로 "회사"에 대하여 그 변경사항을 알려야 합니다.',
      },
      {
        text: '3. 제2항의 변경사항을 "회사"에 알리지 않아 발생한 불이익에 대하여 "회사"는 책임지지 않습니다.',
      },
    ],
  },
  {
    title: "제 9 조 (개인정보보호 의무)",
    contents: [
      {
        text: '1. "회사"는 "개인정보보호법", "정보통신망법" 등 관계 법령이 정하는 바에 따라 "회원"의 개인정보를 보호하기 위해 최선을 다 합니다. 개인정보의 보호 및 사용에 대해서는 관련법 및 "회사"의 개인정보처리방침이 적용됩니다. 다만, "회사"의 공식 사이트 이외의 링크된 사이트에서는 "회사"의 개인정보 처리방침이 적용되지 않습니다.',
      },
    ],
  },
  {
    title: '제 10 조 ("회원"의 "아이디" 및 "비밀번호"의 관리에 대한 의무)',
    contents: [
      {
        text: '1. "회원"의 "아이디"와 "비밀번호"에 관한 관리책임은 "회원"에게 있으며, 이를 제3자가 이용하도록 하여서는 안 됩니다.',
      },
      {
        text: '2. "회원"은 "아이디" 및 "비밀번호"가 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 이를 즉시 "회사"에 통지하고 "회사"의 안내에 따라야 합니다.',
      },
      {
        text: '3. 제2항의 경우에 해당 "회원"이 "회사"에 그 사실을 통지하지 않거나, 통지한 경우에도 "회사"의 안내에 따르지 않아 발생한 불이익에 대하여 "회사"는 책임지지 않습니다.',
      },
      {
        text: '4. "회원"의 "아이디"는 원칙적으로 변경이 불가하며 부득이한 사유로 인하여 변경하고자 하는 경우에는 해당 "아이디"를 해지하고 재가입해야 합니다.',
      },
      {
        text: '5. "서비스"의 회원 아이디는 "회원" 본인의 동의 하에 "회사" 또는 자회사가 운영하는 사이트의 회원 아이디와 연결될 수 있습니다.',
      },
      {
        text: '6. "회원"의 "아이디"는 다음 각 호에 해당하는 경우에는 "회원"의 요청 또는 "회사"의 직권으로 변경 또는 이용을 정지할 수 있습니다.',
      },
      {
        text: '가) "회사"는 "회원"의 "아이디"가 전화번호 등으로 등록되어 개인정보 유출이 우려되는 경우',
        indentation: 1,
      },
      {
        text: "나) 타인에게 혐오감을 주거나 반사회적 미풍양속에 어긋나는 경우",
        indentation: 1,
      },
      {
        text: '다) "회사" 및 "회사"의 운영자로 오인할 우려가 있는 경우',
        indentation: 1,
      },
      {
        text: "라) 기타 합리적인 사유가 있는 경우",
        indentation: 1,
      },
    ],
  },
  {
    title: '제 11 조 ("회사"의 의무)',
    contents: [
      {
        text: '1. "회사"는 "회원"이 희망한 "서비스" 제공 개시일에 특별한 사정이 없는 한 "서비스"를 이용할 수 있도록 하여야 합니다.',
      },
      {
        text: '2. "회사"는 "회원"이 안전하게 "서비스"를 이용할 수 있도록 개인정보 보호를 위해 보안시스템을 갖추어야 하며 개인정보처리방침을 공시하고 준수합니다.',
      },
      {
        text: '3. "회사"는 서비스 이용과 관련하여 발생하는 "이용자"의 불만 또는 피해구제요청을 적절하게 처리할 수 있도록 필요한 인력 및 시스템을 구비합니다.',
      },
      {
        text: '4. "회사"는 서비스 이용과 관련하여 "회원"으로부터 제기되는 의견이나 불만이 정당하다고 객관적으로 인정될 경우에는 적절한 절차를 거쳐 이를 처리하여야 합니다. "회원"이 제기한 의견이나 불만사항에 대해서는 게시판을 활용하거나 전자우편 등을 통하여 "회원"에게 처리과정 및 결과를 전달합니다.',
      },
    ],
  },
  {
    title: '제 12 조 ("회원"의 의무)',
    contents: [
      {
        text: '1. "회원"은 회원가입 신청 또는 회원정보 변경 시 모든 사항을 사실에 근거하여 본인의 진정한 정보로 작성하여야 하며, 허위 또는 타인의 정보를 등록할 경우 이와 관련된 모든 권리를 주장할 수 없습니다.',
      },
      {
        text: '2. "회원"은 약관에서 규정하는 사항과 기타 "회사"가 정한 "운영정책" 등의 제반 규정, 공지사항 등 "회사"가 공지하는 사항 및 관계 법령을 준수하여야 하며, 기타 "회사"의 업무에 방해가 되는 행위, "회사"의 명예를 손상시키는 행위, 타인에게 피해를 주는 행위를 해서는 안 됩니다.',
      },
      {
        text: '3. "회원"은 "회사"의 사전 승낙 없이 서비스를 이용하여 영업활동을 할 수 없으며, 그 영업활동의 결과에 대해 "회사"는 책임을 지지 않습니다. 또한 "회원"은 이와 같은 영업활동으로 "회사"가 손해를 입은 경우, "회원"은 "회사"에 대해 손해배상의무를 지며, "회사"는 해당 "회원"에 대해 서비스 이용제한 및 적법한 절차를 거쳐 손해배상 등을 청구할 수 있습니다.',
      },
      {
        text: '4. "회원"은 "회사"의 명시적 동의가 없는 한 서비스의 이용권한, 기타 이용계약상의 지위를 타인에게 양도, 증여할 수 없으며 이를 담보로 제공할 수 없습니다.',
      },
      {
        text: '5. "회원"은 "회사" 및 기타 제3자의 지적 재산권을 포함한 제반 권리를 침해하는 행위를 해서는 안 됩니다.',
      },
    ],
  },
  {
    title: '제 13 조 ("서비스"의 제공 등)',
    contents: [
      {
        text: '1. "회사"는 "회원"에게 제공하는 일체의 서비스 등 "회원"이 인터넷과 모바일로 이용할 수 있는 다양한 서비스를 제공합니다.',
      },
      {
        text: '2. 서비스 이용은 "회사"의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴, 1일 24시간 운영을 원칙으로 합니다. 단, "회사"는 시스템 정기점검, 증설 및 교체를 위해 "회사"가 정한 날이나 시간에 "서비스"를 일시 중단할 수 있으며, 예정되어 있는 작업으로 인한 서비스 일시 중단은 "서비스" 내 공지사항 등을 통해 사전에 공지합니다.',
      },
      {
        text: '3. "회사"는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우 사전 예고 없이 일시적으로 "서비스"의 전부 또는 일부를 중단할 수 있습니다. 이 경우 "회사"는 "회원"이 "서비스"에 등록한 전자우편 주소 또는 "회사"의 게시판, "서비스"의 공지사항에 게시하여 "회원"에게 통지합니다. 다만, "회사"가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.',
      },
    ],
  },
  {
    title: '제 14 조 ("서비스"의 변경)',
    contents: [
      {
        text: '1. "회사"는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 "서비스"를 변경할 수 있습니다.',
      },
      {
        text: '2. "서비스"의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우에는 변경사유, 변경될 서비스의 내용 및 제공일자 등은 그 변경 전에 해당 서비스 초기화면에 게시하여야 합니다.',
      },
      {
        text: '3. "회사"는 무료로 제공되는 서비스의 일부 또는 전부를 "회사"의 정책 및 운영의 필요상 수정, 중단, 변경할 수 있으며, 이에 대하여 관련법에 특별한 규정이 없는 한 "회원"에게 별도의 보상을 하지 않습니다.',
      },
    ],
  },
  {
    title: "제 15 조 (정보의 제공 및 광고의 게재)",
    contents: [
      {
        text: '1. "회사"는 "서비스"를 운영함에 있어 각종 정보를 서비스화면에 게재하거나 문자메시지, 전자우편, 어플리케이션 Push 알림 등의 방법으로 "이용자"에게 제공할 수 있습니다.',
      },
      {
        text: '2. "회사"는 서비스의 운영과 관련하여 홈페이지, 서비스화면, 문자메시지, 전자우편, 어플리케이션 Push 알림 등에 광고 등을 게재할 수 있습니다. 다만, "회사"가 광고 등을 문자메시지, 전자우편, 어플리케이션 Push 알림 등을 이용하여 발송하는 경우 수신 동의 여부를 확인한 후 수신 동의한 "이용자"에 한하여 이를 발송합니다.',
      },
      {
        text: '3. "이용자"는 "회사"가 제공하는 서비스와 관련하여 게시물 또는 기타 정보를 변경, 수정, 제한하는 등의 조치를 취하지 않습니다.',
      },
      {
        text: '4. "이용자"가 서비스상에 게재되어 있는 광고를 이용하거나 서비스를 통한 광고주의 판촉활동에 참여하는 등의 방법으로 교신 또는 거래를 하는 것은 전적으로 "이용자"와 광고주 간의 문제입니다. 만약 "이용자"와 광고주간에 문제가 발생할 경우에도 "이용자"와 광고주가 직접 해결하여야 하며, 이와 관련하여 "회사"가 광고주의 위법행위에 적극 가담하였다거나, 위법행위를 고의 또는 중과실로 방치하였다는 등의 사정이 없는 한 "회사"는 어떠한 책임도 부담하지 않습니다.',
      },
    ],
  },
  {
    title: "제 16 조 (게시물에 대한 저작권)",
    contents: [
      {
        text: '1. "회원"이 "서비스" 내에 게시한 게시물은 저작권법에 의해 보호를 받습니다. 다만 "회사"가 작성한 게시물에 대한 저작권 등 제 권리는 "회사"에 귀속됩니다.',
      },
      {
        text: '2. "회원"은 자신의 게시물을 "회사"가 국내외에서 다음 각 호의 어느 하나의 목적으로 사용하는 것을 허락합니다.',
      },
      {
        text: '가) "회사"의 "서비스" 또는 "회사"의 공식 사이트 이외의 "회사"의 업무와 연계된 사이트 내에서 "회원"의 "게시물"의 복제, 전송, 전시 및 우수 게시물을 "회사"의 "서비스" 또는 "회사"의 공식 사이트 이외의 "회사"의 업무와 연계된 사이트 화면 등에 노출하기 위하여 "회원" 게시물의 크기를 변환하거나 이미지 변경, 단순화하는 등의 방식으로 수정하는 것',
        indentation: 1,
      },
      {
        text: '나) "회사"의 "서비스"를 홍보하기 위한 목적으로 미디어, 언론기관 등에게 "회원"의 "게시물" 내용을 보도, 방영하게 하는 것. 단, 이 경우 "회사"는 "회원"의 개별 동의 없이 미디어, 언론기관 등에게 개인정보를 제공하지 않습니다.',
        indentation: 1,
      },
      {
        text: '3. 전항의 규정에도 불구하고 "회사"가 "회원"의 게시물을 전항 각 호의 어느 하나에 기재된 목적 이외의 방법으로 사용하는 경우에는 사전에 해당 "회원"으로부터 동의를 얻어야 합니다. 게시물에 대한 "회사"의 사용 요청, "회원"의 동의 및 동의철회는 전화, 전자우편 등 "회사"가 요청하는 방식에 따릅니다. 이 경우 "회사"는 "게시물"의 출처를 표시합니다.',
      },
      {
        text: '4. "회원"이 "서비스"의 "이용계약"을 "해지" 하더라도 "회원"의 명의로 "서비스"에 등록한 게시물을 삭제되지 않습니다. "회원"은 자신의 게시물이 회원 탈퇴 후 "서비스"에서 이용되는 것을 원하지 않는 경우 회원 탈퇴 전에 직접 "게시물"을 삭제하여야 합니다.(단, 제3자가 다시 게시하거나 저장한 게시물은 삭제되지 않을 수 있습니다.)',
      },
      {
        text: '5. "회사"는 "회사"의 운영정책상의 판단, 합병, 영업양도 등의 사유로 원래의 게시물의 내용을 변경하지 않고 "게시물"의 게시 위치를 변경할 수 있습니다.',
      },
    ],
  },
  {
    title: "제 17 조 (개인위치정보의 이용 또는 제공)",
    contents: [
      {
        text: '1. "회사"는 개인위치정보주체로부터 동의를 받아 수집한 개인위치정보를 이용하여 서비스를 제공할 수 있으며, 구체적인 내용은 아래와 같습니다.',
      },
      {
        text: "가) 사업자 정보",
        indentation: 1,
      },
      {
        text: "ㄱ) 상호: 주식회사 메디올로지(Mediology Co., Ltd.)",
        indentation: 2,
      },
      {
        text: "ㄴ) 주소: 서울특별시 종로구 경희궁길27 블루코브스퀘어 3층",
        indentation: 2,
      },
      {
        text: "ㄷ) 이메일 주소: be@healthier.kr",
        indentation: 2,
      },
      {
        text: "나) 서비스의 내용",
        indentation: 1,
      },
      {
        text: "이용자 위치 또는 검색한 위치 주변의 병원과 약국을 거리순에 따라 노출",
        indentation: 2,
      },
      {
        text: "다) 개인위치정보 수집방법",
        indentation: 1,
      },
      {
        text: "이용자의 동의를 득한 뒤 이용자가 서비스 이용에 사용 중인 단말기의 GPS 기능을 통해 이용자의 위치정보를 수집",
        indentation: 2,
      },
      {
        text: '2. "회원" 및 법정대리인의 권리와 그 행사방법은 제소 당시 이용자의 주소에 의하며, 주소가 없는 경우 거소를 관할하는 지방법원의 전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자인 경우에는 민사소송법상의 관할법원에 제기합니다.',
      },
      {
        text: '3. "회사"는 위치정보의 보호 및 이용 등에 관한 법률 제16조 제2항에 근거하여 타사업자 또는 이용 고객과의 요금정산 및 민원처리를 위해 위치정보 이용 제공 사실 확인자료를 자동 기록 보존하며, 분쟁발생 시 조정 등을 위해 해당 자료는 1년간 보관합니다.',
      },
      {
        text: '4. "회사"는 개인위치정보를 "회원"이 지정하는 제3자에게 제공하는 경우 개인위치정보를 수집한 당해 통신 단말장치로 매회 회원에게 제공받는 자, 제공일시 및 제공목적을 즉시 통보합니다. 단, 아래 각호의 1에 해당하는 경우에는 회원이 미리 특정하여 지정한 통신 단말장치 또는 전자우편 주소로 통보합니다.',
      },
      {
        text: "가) 개인위치정보를 수집한 당해 . 통신단말장치가 문자, 음성 또는 영상의 수신기능을 갖추지 아니한 경우",
        indentation: 1,
      },
      {
        text: "나) 회원이 온라인 게시 등의 방법으로 통보할 것을 미리 요청한 경우",
        indentation: 1,
      },
    ],
  },
  {
    title: "제 18 조 (개인위치정보주체의 권리)",
    contents: [
      {
        text: '1. "회원"은 "회사"에 대하여 언제든지 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의의 전부 또는 일부를 철회할 수 있습니다. 이 경우 회사는 수집한 개인위치정보 및 위치정보 이용, 제공사실 확인자료를 파기합니다.',
      },
      {
        text: '2. "회원"은 "회사"에 대하여 언제든지 개인위치정보의 수집, 이용 또는 제공의 일시적인 중지를 요구할 수 있으며, 회사는 이를 거절할 수 없고 이를 위한 기술적 수단을 갖추고 있습니다.',
      },
      {
        text: '3. "회원"은 "회사"에 대하여 아래 각 호의 자료에 대한 열람 또는 고지를 요구할 수 있고, 당해 자료에 오류가 있는 경우 그 정정을 요구할 수 있습니다. 이 경우 "회사"는 정당한 사유 없이 회원의 요구를 거절할 수 없습니다.',
      },
      {
        text: "가) 본인에 대한 위치정보 수집, 이용, 제공사실 확인자료",
        indentation: 1,
      },
      {
        text: "나) 본인의 개인위치정보가 위치정보의 보호 및 이용 등에 관한 법률 또는 다른 법률 규정에 의하여 제3자에게 제공된 이유 및 내용",
        indentation: 1,
      },
      {
        text: '4. "회원"은 제1항 내지 제3항의 권리행사를 위해 회사에 소정의 절차를 통해 요구할 수 있습니다.',
        indentation: 1,
      },
    ],
  },
  {
    title: "제 19 조 (가명정보 처리에 관한 사항)",
    contents: [
      {
        text: '가명정보는 개인정보 일부를 삭제, 대체하는 등 가명처리함으로써 원래 상태로 복원하기 위한 추가 정보의 사용, 결합 없이는 특정개인을 알아볼 수 없는 정보입니다. "회사"는 개인정보보호법 제28조의2, 제28조의 3에 근거하여 가명정보를 처리하고 있습니다.',
      },
      {
        text: '1. "회사"는 개인정보 보호법 제28조의4(가명정보에 대한 안전조치 의무 등)에 의거하여 가명정보 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.',
      },
      {
        text: "가) 관리적 조치 : 내부관리계획 수립·시행, 정기적 직원 교육",
        indentation: 1,
      },
      {
        text: "나) 기술적 조치 : 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치",
        indentation: 1,
      },
      {
        text: "다) 물리적 조치 : 데이터에 대한 접근통제",
        indentation: 1,
      },
      {
        text: "2. 가명정보의 처리 목적",
      },
      {
        text: '"회사"는 통계작성, 과학적 연구, 공익적 기론보존을 위해 등을 위하여 정보주체의 동의 없이 가명정보를 처리할 수 있습니다.',
      },
      {
        text: "3. 가명정보의 처리 및 보유기간",
      },
      {
        text: '"회사"는 정보주체의 가명정보를 3년간 처리 및 보유할 수 있습니다. 가명정보를 처리하는 과정에서 특정 개인을 알아볼 수 있는 정보가 생성된 경우에는 즉시 해당 정보의 처리를 중지하고, 지체 없이 회수·파기하여야 합니다.',
      },
      {
        text: "4. 가명정보의 제3자 제공에 관한 사항",
      },
      {
        text: '"회사"는 정보주체의 개인정보를 개인정보의 처리 목적에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공하고 그 이외에는 정보주체의 개인정보를 제3자에게 제공하지 않습니다.',
      },
      {
        text: "가) 개인정보를 제공받는 자 : 가명정보 매칭 상대방",
        indentation: 1,
      },
      {
        text: "나) 개인정보를 제공받는 자의 이용 목적 : 가명정보 결합 매칭 협의, 가명정보 제공 및 결합 수행",
        indentation: 1,
      },
      {
        text: "다) 제공하는 기본 개인정보 항목 : 성별, 연령, 위치정보, 증상감별 기록",
        indentation: 1,
      },
      {
        text: "라) 개인정보를 제공 받는 자의 개인정보 보유 및 이용 기간 : 가명정보 결합 매칭 지원 서비스의 종료 또는 매칭을 통한 가명정보 결합 완료 시까지",
        indentation: 1,
      },
      {
        text: "5. 가명정보 처리의 위탁에 관한 사항",
      },
      {
        text: '가명정보의 결합은 국가에서 지정한 "결합전문기관"을 통해서만 진행합니다.',
      },
      {
        text: "6. 가명처리하는 개인정보의 항목",
      },
      {
        text: "성별, 연령, 위치정보, 증상감별 기록",
      },
    ],
  },
  {
    title: "제 20 조 (법정대리인의 권리)",
    contents: [
      {
        text: '1. "회사"는 14세 미만의 회원의 개인정보 및 위치정보를 이용한 위치기반서비스 제공, 개인정보 및 위치정보의 제3자 제공에 대한 동의를 당해 회원과 당해 회원의 법정대리인으로부터 동의를 받아야 합니다. 이 경우 법정대리인은 제18조에 의한 회원의 권리를 모두 가집니다.',
      },
    ],
  },
  {
    title: "제 21 조 (개인정보 및 위치정보관리책임자의 지정)",
    contents: [
      {
        text: "1. 회사는 개인정보 및 위치정보를 적절히 관리․보호하고 정보주체의 불만을 원활히 처리할 수 있도록 실질적인 책임을 질 수 있는 지위에 있는 자를 개인정보 책임자 및 위치정보관리책임자로 지정해 운영합니다.",
      },
      {
        text: "2. 개인정보 책임자 및 위치정보관리책임자는 위치기반서비스를 제공하는 부서의 부서장으로서 구체적인 사항은 본 약관의 부칙에 따릅니다.",
      },
    ],
  },
  {
    title: "제 22 조 (손해배상)",
    contents: [
      {
        text: "1. 회사가 위치정보의 보호 및 이용 등에 관한 법률 제15조 내지 제26조의 규정을 위반한 행위로 회원에게 손해가 발생한 경우 회원은 회사에 대하여 손해배상 청구를 할 수 있습니다. 이 경우 회사는 고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.",
      },
      {
        text: "2. 회원이 본 약관의 규정을 위반하여 회사에 손해가 발생한 경우 회사는 회원에 대하여 손해배상을 청구할 수 있습니다. 이 경우 회원은 고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.",
      },
    ],
  },
  {
    title: "제 23 조 (이용제한 등)",
    contents: [
      {
        text: '1. "회사"는 "회원"이 이 약관의 의무를 위반하거나 "서비스"의 정상적인 운영을 방해한 경우, 경고, 일시정지, 영구이용정지 등으로 "서비스" 이용을 단계적으로 제한할 수 있습니다.',
      },
      {
        text: '2. "회사"는 전항에도 불구하고, "저작권법" 및 "컴퓨터프로그램보호법"을 위반한 불법프로그램의 제공 및 운영방해, "정보통신망법"을 위반한 불법통신 및 해킹, 악성프로그램의 배포, 접속권한 초과행위 등과 같이 관련법을 위반한 경우에는 즉시 영구이용정지를 할 수 있습니다. 본 항에 따른 영구이용정지 시 "서비스" 이용을 통해 획득한 혜택 등은 모두 소멸되며, "회사"는 이에 대해 별도로 보상하지 않습니다.',
      },
      {
        text: '3. "회사"는 본 조의 이용제한 범위 내에서 제한의 조건 및 세부내용은 "서비스"의 "운영정책"에서 정하는 바에 의합니다.',
      },
      {
        text: '4. 본 조에 따라 "서비스" 이용을 제한하거나 계약을 "해지"하는 경우에는 "회사"는 제9조["회원"에 대한 통지]에 따라 통지합니다.',
      },
      {
        text: '5. "회원"은 본 조에 따른 이용제한 등에 대해 "회사"가 정한 절차에 따라 이의신청을 할 수 있습니다. 이 때 이의가 정당하다고 "회사"가 인정하는 경우 "회사"는 즉시 "서비스"의 이용을 재개합니다.',
      },
    ],
  },
  {
    title: "제 24 조 (책임제한)",
    contents: [
      {
        text: '1. "회사"는 천재지변, 전쟁, 기간통신사업자의 서비스 중지 또는 이에 준하는 불가항력으로 인하여 "서비스"를 제공할 수 없는 경우에는 "서비스" 제공에 대한 책임이 면제됩니다.',
      },
      {
        text: '2. "회사"는 서비스용 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로 발생한 손해에 대한 책임이 면제됩니다.',
      },
      {
        text: '3. "회사"는 "회원"의 귀책사유로 인한 "서비스" 이용의 장애에 대하여는 책임을 지지 않습니다.',
      },
      {
        text: '4. "회사"는 "회원"이 "서비스"를 이용하여 기대하는 수익을 얻지 못하거나 상실한 것에 대하여 책임을 지지 않으며, "서비스"를 이용하면서 얻은 자료로 인한 손해에 대하여 책임을 지지 않습니다.',
      },
      {
        text: '5. "회사"는 "회원"이 "서비스"에 관련하여 게재한 정보, 자료, 사실의 신뢰도 정확성 등의 내용에 관하여는 책임을 지지 않습니다.',
      },
      {
        text: '6. "회사"는 "회원" 간 또는 "회원"과 제3자 상호간에 "서비스"를 매개로 하여 거래 등을 한 경우에는 책임이 면제됩니다. "회사"는 무료로 제공되는 서비스 이용과 관련하여 관련법에 특별한 규정이 없는 한 책임을 지지 않습니다.',
      },
    ],
  },
  {
    title: "제 25 조 (준거법 및 재판관할)",
    contents: [
      {
        text: '1. 서비스 이용과 관련하여 "회사"와 "회원" 사이에 분쟁이 발생한 경우, "회사"와 "회원"은 분쟁의 해결을 위해 성실히 협의합니다',
      },
      {
        text: '2. 제1항의 협의에서도 분쟁이 해결되지 않을 경우 양 당사자는 "회원"의 주소 또는 거소를 관할하는 지방법원을 관할 법원으로 합니다.',
      },
    ],
  },
  {
    title: "제 26 조 (포인트의 적립, 이용 및 소멸)",
    contents: [
      {
        text: "1. 포인트는 아래의 방법을 통해 획득하실 수 있습니다.",
      },
      {
        text: "가) 건강챌린지 참여 보상",
        indentation: 1,
      },
      {
        text: "나) 회사가 다양한 방법을 통하여 포인트를 지급 하겠다고 약속한 경우",
        indentation: 1,
      },
      {
        text: "2. 포인트의 유효기간은 마지막 접속 기준 1년을 원칙으로 하며, 유효기간 내 사용하지 않을 경우 소멸됩니다. 다만, 사전특약(사전 안내 포함)이 있는 포인트의 유효기간은 각각 별도로 설정될 수 있습니다.",
      },
      {
        text: "3. 회원 탈퇴 시 사용하지 않은 포인트는 즉시 소멸되며, 탈퇴 후 재가입하더라도 소멸된 포인트는 복구되지 않습니다.",
      },
      {
        text: "4. 포인트의 적립 또는 사용이 없는 비활성화 상태가 3개월 이상 계속된 회원의 포인트는 소멸될 수 있습니다.",
      },
      {
        text: "5. 포인트를 제 3자 또는 다른 아이디에게 양도하거나 유상으로 거래할 수 없습니다.",
      },
      {
        text: "6. 포인트는 회사가 정한 방침에 따라 실물 리워드로 전환할 수 있습니다.",
      },
      {
        text: "7. 한번 리워드로 전환한 포인트는 다시 포인트로 전환하거나 취소할 수 없습니다.",
      },
      {
        text: "8. 포인트는 회사가 제공하는 실물 리워드로만 전환 가능하며, 현금화가 불가능합니다.",
      },
      {
        text: "9. 회사가 승인하지 않은 방법 또는 허위 정보 제공, 이용약관에 위배되는 등의 부정한 방법으로 포인트를 획득하거나 부정한 목적이나 용도로 포인트를 사용하는 경우, 회사가 포인트의 사용을 제한하거나 회사가 정한 방법으로 이를 회수할 수 있으며 포인트를 사용한 구매 신청을 취소하거나 회원의 자격을 정지할 수 있습니다.",
      },
      {
        text: "10. 어플의 사용이 없는 비활성화 상태가 1년 이상 계속된 회원의 포인트는 소멸됩니다.",
      },
      {
        text: "11. 회사의 포인트 관련 정책은 모든 회원에게 동일하게 적용됩니다. 단, 휴면회원의 경우 관계법령에 따라 고지, 처리 등이 제한될 수 있습니다.",
      },
    ],
  },
  {
    title: "제 27 조 (리워드 신청 및 공급)",
    contents: [
      {
        text: "1. 회원은 건강챌린지 리워드 신청 이용 시 본 약관 및 회사가 정한 규정에 따라 아래와 같거나 유사한 방법으로 리워드를 신청하며, 회사는 이용자가 신청을 함에 있어서 다음의 각 내용을 알기 쉽게 제공하여야 합니다.",
      },
      {
        text: "가) 리워드의 선택",
        indentation: 1,
      },
      {
        text: "나) 리워드를 수령할 사람의 전화번호의 입력",
        indentation: 1,
      },
      {
        text: "다) 리워드 신청 및 이에 관한 확인 또는 회사의 확인에 대한 동의",
        indentation: 1,
      },
      {
        text: "2. 회사는 건강챌린지 리워드 신청이 있는 경우 이용자에게 수신확인통지를 합니다.",
      },
      {
        text: "3. 회사는 건강챌린지 리워드 지급 시스템에 대하여 이용자와 공급시기에 관하여 별도의 약정이 없는 이상, 이용자가 신청을 한 날부터 7일 이내에 리워드를 전송할 수 있도록 합니다. 다만 회사가 이미 리워드 전송을 완료하였거나, 전상상의 오류가 발생하였을 경우 3영업일 이내에 조치를 취합니다. 이 때 회사는 이용자가 공급 절차 및 진행 사항을 확인할 수 있도록 적절한 조치를 합니다.",
      },
      {
        text: "4. 공휴일 및 기타 휴무일 또는 천재지변 등의 불가항력적인 사유가 발생하는 경우 그 해당기간은 리워드 지급 소요기간에서 제외합니다.",
      },
      {
        text: "5. 리워드로 수령한 상품권의 유효기간은 전송일로부터 30일이며, 유효기간 만료 후 연장 및 환불이 불가합니다.",
      },
      {
        text: "6. 실물 리워드 별 이용방법 및 유의사항은 모두 상이하므로, 회원은 상품 상세정보와 유의사항을 사전에 확인해야하며, 이용자의 귀책으로 발생하는 모든 문제에 대해서는 회사는 책임을 지지 않습니다.",
      },
      {
        text: "7. 제휴 리워드의 내용은 다른 회사와의 협의상황에 따라 변경될수 있습니다. 제휴 리워드의 이용, 구매금액은 제휴처로부터의 공급금액, 지급 수수료, 운영비용 등을 고려하여 산정이 되므로, 기존 판매가와 다를 수 있습니다.",
      },
      {
        text: "8. 커피, 편의점 등 현장에서 사용되는 리워드의 경우 회사가 회원의 모바일기기로 해당 바코드를 전송함으로써 적법하게 이행을 완료한 것으로 봅니다.",
      },
      {
        text: "9. 서비스 내에서 구매하신 쿠폰을 회원의 단순 변심으로 환불이 불가능합니다.",
      },
      {
        text: "10. 제휴컨텐츠 이용과 관련한 분쟁에서 명시적인 책임소재가 제휴된 업체 측에 있을 경우, 회사는 책임을 지지 않습니다.",
      },
    ],
  },
  {
    title: "제 28 조 (헬시어 증상감별 서비스의 책임)",
    contents: [
      {
        text: "1. 회사가 제공하는 증상감별 서비스는  진단, 처방을 비롯한 의료 행위가 아니며, 이를 이용약관 및 서비스 내 고지하고 있습니다.",
      },
      {
        text: "2. 이용자 혹은 회원이 자신의 증상과 연관된 질병에 대해 알고자 할 경우, 가장 유사한 증상을 일으키는 질환에 대한 정보를 프로그램에 기반하여 제공할 뿐, 회사는 이용자 혹은 회원 본인의 건강에 관한 의사 결정에 대해 책임이 없습니다.",
      },
      {
        text: "3. 유사한 증상을 일으키는 질환 목록을 최종 진단으로 오인해서는 아니되며, 해당 결과는 의료진의 진료를 대신할 수 없으므로, 정확한 진단을 위해 꼭 의료진과 전문적인 상담을 받을 것을 권고합니다.",
      },
      {
        text: "4. 회사는 서비스 내에서 정보 제공 시, 정보 제공의 출처가 되는 공신력 있는 기관에서 발행된 정보들의 출처를 모두 기재하고 있습니다.",
      },
      {
        text: "5. 회원이 겪고 있는 증상이 경미한 증상이 아니라면, 반드시 가까운 병원이나 응급실에 내원하거나 119 안전신고센터를 이용하시기 바랍니다.",
      },
    ],
  },
  {
    title: "부칙",
    contents: [
      {
        text: "본 약관은 2025년 02월 07일부터 시행합니다.",
      },
    ],
  },
];

export const REWARD_TERMS: any = [
  {
    title:
      "1. 회원은 건강챌린지 리워드 신청 이용 시 본 약관 및 회사가 정한 규정에 따라 아래와 같거나 유사한 방법으로 리워드를 신청하며, 회사는 이용자가 신청을 함에 있어서 다음의 각 내용을 알기 쉽게 제공하여야 합니다.",
    contents: [
      {
        text: "가) 리워드의 선택",
        indentation: 1,
      },
      {
        text: "나) 리워드를 수령할 사람의 전화번호의 입력",
        indentation: 1,
      },
      {
        text: "다) 리워드 신청 및 이에 관한 확인 또는 회사의 확인에 대한 동의",
        indentation: 1,
      },
    ],
  },
  {
    title:
      "2. 회사는 건강챌린지 리워드 신청이 있는 경우 이용자에게 수신확인통지를 합니다.",
  },
  {
    title:
      "3. 회사는 건강챌린지 리워드 지급 시스템에 대하여 이용자와 공급시기에 관하여 별도의 약정이 없는 이상, 이용자가 신청을 한 날부터 7일 이내에 리워드를 전송할 수 있도록 합니다. 다만 회사가 이미 리워드 전송을 완료하였거나, 전상상의 오류가 발생하였을 경우 3영업일 이내에 조치를 취합니다. 이 때 회사는 이용자가 공급 절차 및 진행 사항을 확인할 수 있도록 적절한 조치를 합니다.",
  },
  {
    title:
      "4. 공휴일 및 기타 휴무일 또는 천재지변 등의 불가항력적인 사유가 발생하는 경우 그 해당기간은 리워드 지급 소요기간에서 제외합니다.",
  },
  {
    title:
      "5. 리워드로 수령한 상품권의 유효기간은 전송일로부터 30일이며, 유효기간 만료 후 연장 및 환불이 불가합니다.",
  },
  {
    title:
      "6. 실물 리워드 별 이용방법 및 유의사항은 모두 상이하므로, 회원은 상품 상세정보와 유의사항을 사전에 확인해야하며, 이용자의 귀책으로 발생하는 모든 문제에 대해서는 회사는 책임을 지지 않습니다.",
  },
  {
    title:
      "7. 제휴 리워드의 내용은 다른 회사와의 협의상황에 따라 변경될 수 있습니다. 제휴 리워드의 이용, 구매금액은 제휴처로부터의 공급금액, 지급 수수료, 운영비용 등을 고려하여 산정이 되므로, 기존 판매가와 다를 수 있습니다.",
  },
  {
    title:
      "8. 커피, 편의점 등 현장에서 사용되는 리워드의 경우 회사가 회원의 모바일기기로 해당 바코드를 전송함으로써 적법하게 이행을 완료한 것으로 봅니다.",
  },
  {
    title:
      "9. 서비스 내에서 구매하신 쿠폰을 회원의 단순 변심으로 환불이 불가능합니다.",
  },
  {
    title:
      "10. 제휴컨텐츠 이용과 관련한 분쟁에서 명시적인 책임소재가 제휴된 업체 측에 있을 경우, 회사는 책임을 지지 않습니다.",
  },
];

export const ENGLISH_PRIVACY_POLICY: TTerms = [
  {
    title: "",
    contents: [
      {
        text: 'Mediology Co., Ltd. ("Mediology", "we", "us") values your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, share, and protect your information when you use the Healthier mobile application and related services ("Healthier").',
      },
      {
        text: "By using Healthier, you agree to the practices described in this Privacy Policy.",
      },
    ],
  },
  {
    title: "1. Introduction",
    contents: [
      {
        text: 'Mediology Co., Ltd. ("Mediology", "we", "us") values your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, share, and protect your information when you use the Healthier mobile application and related services ("Healthier").',
      },
      {
        text: "By using Healthier, you agree to the practices described in this Privacy Policy.",
      },
    ],
  },
  {
    title: "2. Information We Collect",
    contents: [
      {
        text: "We may collect the following categories of information:",
      },
      {
        text: "Personal Information: such as your name, email address, phone number, and other identifiers you provide.",
        listType: true,
      },
      {
        text: "Health and Wellness Information: including symptoms, lifestyle information, and responses you submit for assessments.",
        listType: true,
      },
      {
        text: "Technical Information: including device identifiers, IP address, browser type, operating system, and usage activity within the app.",
        listType: true,
      },
      {
        text: "Location Information: if you allow, we may collect location data to provide location-based features (e.g., nearby healthcare facilities).",
        listType: true,
      },
    ],
  },
  {
    title: "3. How We Use Your Information",
    contents: [
      {
        text: "We may use your information to:",
      },
      {
        text: "Provide Healthier's services, including symptom assessments and personalized health insights.",
        listType: true,
      },
      {
        text: "Improve, maintain, and develop our services.",
        listType: true,
      },
      {
        text: "Communicate with you about updates and support.",
        listType: true,
      },
      {
        text: "Personalize your experience within Healthier.",
        listType: true,
      },
      {
        text: "Comply with applicable laws and protect our legal rights.",
        listType: true,
      },
      {
        text: "Conduct internal analytics and service enhancement.",
        listType: true,
      },
    ],
  },
  {
    title: "4. How We Share Your Information",
    contents: [
      {
        text: "We may share your information with:",
      },
      {
        text: "Service Providers: who process data on our behalf to support app functionality and improvements.",
        listType: true,
      },
      {
        text: "Legal and Regulatory Authorities: when required by law, legal process, or to protect our rights.",
        listType: true,
      },
      {
        text: "With Your Consent: in cases where you explicitly consent to sharing information (e.g., connecting with a healthcare provider or external platform).",
        listType: true,
      },
      {
        text: "We do not sell your personal information to third parties.",
      },
    ],
  },
  {
    title: "5. Your Privacy Rights (CCPA)",
    contents: [
      {
        text: "If you are a California resident, you have the following rights under the CCPA:",
      },
      {
        text: "Right to Know: Request disclosure of the personal information we collect, use, and share.",
        listType: true,
      },
      {
        text: "Right to Delete: Request deletion of your personal information.",
        listType: true,
      },
      {
        text: 'Right to Opt-Out: Request to opt-out of any "sale" of personal information (Healthier does not sell your information).',
        listType: true,
      },
      {
        text: "Non-Discrimination: Exercise your privacy rights without discrimination.",
        listType: true,
      },
      {
        text: "To exercise your rights, contact us at corp@mediology.ai.",
      },
    ],
  },
  {
    title: "6. Data Security",
    contents: [
      {
        text: "We use reasonable administrative, technical, and physical safeguards to protect your personal information from unauthorized access, use, or disclosure.",
      },
    ],
  },
  {
    title: "7. Data Retention",
    contents: [
      {
        text: "We retain your personal information only as long as necessary to fulfill the purposes described in this Privacy Policy unless a longer retention period is required by law.",
      },
    ],
  },
  {
    title: "8. Children's Privacy",
    contents: [
      {
        text: "Healthier is intended for users aged 12 and above. Users under 18 should use the service with the involvement of a parent or legal guardian.",
      },
      {
        text: "We do not knowingly collect personal information from children under 13. If we learn we have collected such information, we will take steps to delete it promptly.",
      },
    ],
  },
  {
    title: "9. Changes to This Privacy Policy",
    contents: [
      {
        text: "We may update this Privacy Policy periodically to reflect changes in our practices. We will notify you of material changes as required by law. Your continued use of Healthier after updates constitutes acceptance of the revised policy.",
      },
    ],
  },
  {
    title: "10. Contact Us",
    contents: [
      {
        text: "For questions about this Privacy Policy or to exercise your privacy rights, please contact us:",
      },
      {
        text: "Email: corp@mediology.ai",
        isBackground: true,
      },
    ],
  },
];

export const ENGLISH_TERMS_OF_SERVICE: TTerms = [
  {
    title: "HIPAA and FDA Compliance Notice",
    contents: [
      {
        text: "Healthier complies with HIPAA and implements reasonable safeguards to protect personal health information. Healthier is not an FDA-regulated medical device and does not diagnose, treat, or prevent diseases. Consult a healthcare professional for medical advice. In emergencies, call 911.",
      },
    ],
  },
  {
    title: "1. Welcome to Healthier",
    contents: [
      {
        text: "Healthier is a digital health platform by Mediology Co., Ltd. providing symptom assessments, health insights, and location-based resources. By using Healthier, you agree to these Terms and our Privacy Policy.",
      },
    ],
  },
  {
    title: "2. Legal Relationship",
    contents: [
      {
        text: 'These Terms create a legally binding agreement between you and Mediology Co., Ltd. ("Mediology," "we," "us").',
      },
    ],
  },
  {
    title: "3. User Eligibility",
    contents: [
      {
        text: "You must be at least 12 years old or have guardian consent to use Healthier.",
      },
    ],
  },
  {
    title: "4. Data We Collect",
    contents: [
      {
        text: "We protect your data in compliance with HIPAA, CCPA, and other applicable laws. See our Privacy Policy for details.",
      },
    ],
  },
  {
    title: "5. About Healthier's Service",
    contents: [
      {
        text: "Healthier provides AI-powered symptom assessments and health information for educational purposes only and does not replace professional medical care.",
      },
    ],
  },
  {
    title: "6. Account Creation",
    contents: [
      {
        text: "You may need to create an account with accurate information. You are responsible for maintaining the confidentiality of your login credentials and all activities under your account.",
      },
    ],
  },
  {
    title: "7. Your License to Use Healthier",
    contents: [
      {
        text: "We grant you a limited, non-exclusive, non-transferable, revocable license to use Healthier for personal, non-commercial purposes in compliance with these Terms.",
      },
    ],
  },
  {
    title: "8. User Obligations",
    contents: [
      {
        text: "You agree not to misuse Healthier, infringe intellectual property rights, attempt unauthorized access, or violate applicable laws while using the service.",
      },
    ],
  },
  {
    title: "9. Intellectual Property",
    contents: [
      {
        text: "All content, trademarks, service marks, logos, and intellectual property on Healthier are owned by Mediology or its licensors. You may not copy, reproduce, distribute, modify, or create derivative works from any part of the service without prior written consent from Mediology.",
      },
    ],
  },
  {
    title: "10. Termination",
    contents: [
      {
        text: "You may stop using Healthier at any time. Mediology may suspend or terminate your account if you violate these Terms.",
      },
    ],
  },
  {
    title: "11. Disclaimers and Limitations",
    contents: [
      {
        text: 'Healthier is provided "as is" and "as available." Mediology disclaims all warranties, express or implied, and is not liable for any indirect, incidental, or consequential damages arising from your use of Healthier.',
      },
    ],
  },
  {
    title: "12. Healthier Symptom Assessment Disclaimer",
    contents: [
      {
        text: "Healthier's symptom assessments and condition information do not constitute medical diagnoses or treatment.",
        listType: true,
      },
      {
        text: "Information provided is for informational purposes only; decisions regarding your health are your responsibility.",
        listType: true,
      },
      {
        text: "Listed conditions are not final diagnoses and should not replace professional medical consultation.",
        listType: true,
      },
      {
        text: "Healthier references reputable data sources, cited within the service.",
        listType: true,
      },
      {
        text: "For serious symptoms, seek immediate medical care or call 911.",
        listType: true,
      },
    ],
  },
  {
    title: "13. Medicine Recommendation and Linking Disclaimer",
    contents: [
      {
        text: "Healthier may suggest over-the-counter medications for informational purposes only and does not sell, distribute, or deliver medications. Links to third-party platforms for purchasing medications are provided for user convenience, and Mediology is not responsible for third-party products, services, or delivery. Consult a healthcare professional before taking any medications.",
      },
    ],
  },
  {
    title: "14. Third-Party Services",
    contents: [
      {
        text: "Healthier may link to third-party services governed by their terms. Mediology is not responsible for these third-party services.",
      },
    ],
  },
  {
    title: "15. Modifications to Service",
    contents: [
      {
        text: "Mediology may modify, suspend, or discontinue Healthier or any features without notice when necessary for improvements or legal compliance.",
      },
    ],
  },
  {
    title: "16. Amendments to Terms",
    contents: [
      {
        text: "Mediology may update these Terms at any time. Users will be notified of material changes, and continued use constitutes acceptance.",
      },
    ],
  },
  {
    title: "17. Arbitration and Class Action Waiver",
    contents: [
      {
        text: "You agree to resolve disputes with Mediology through binding arbitration on an individual basis, waiving any rights to participate in class actions. You may opt out of arbitration within 30 days of accepting these Terms by contacting corp@mediology.ai.",
      },
    ],
  },
  {
    title: "18. Indemnification",
    contents: [
      {
        text: "You agree to indemnify and hold Mediology harmless from any claims, damages, or expenses arising from your misuse of Healthier or violation of these Terms.",
      },
    ],
  },
  {
    title: "19. Limitation of Liability",
    contents: [
      {
        text: "To the fullest extent permitted by law, Mediology's liability under these Terms will not exceed $100.",
      },
    ],
  },
  {
    title: "20. Governing Law and Jurisdiction",
    contents: [
      {
        text: "These Terms are governed by the laws of the State of Delaware and applicable U.S. federal laws. Disputes will be resolved in the courts of your state or relevant federal court, except where arbitration is applicable.",
      },
    ],
  },
  {
    title: "21. Severability",
    contents: [
      {
        text: "If any provision of these Terms is held to be invalid or unenforceable, the remaining provisions will remain in full effect.",
      },
    ],
  },
  {
    title: "22. Entire Agreement",
    contents: [
      {
        text: "These Terms, together with the Privacy Policy, constitute the entire agreement between you and Mediology regarding your use of Healthier.",
      },
    ],
  },
  {
    title: "23. Contact",
    contents: [
      {
        text: "For questions or legal notices, contact us at corp@mediology.ai.",
      },
    ],
  },
];

export const ENGLISH_HIPAA_NOTICE: TTerms = [
  {
    title: "",
    contents: [
      {
        text: 'This Notice of Privacy Practices ("Notice") describes how Mediology Co., Ltd. ("Mediology", "we", "us") may use and disclose your Protected Health Information ("PHI") collected through Healthier and how you can access your information.',
      },
      {
        text: 'We are required by the Health Insurance Portability and Accountability Act of 1996 ("HIPAA") to maintain the privacy of your PHI and to inform you of our legal duties and privacy practices with respect to your PHI.',
      },
    ],
  },
  {
    title: "1. Purpose of This Notice",
    contents: [
      {
        text: 'This Notice of Privacy Practices ("Notice") describes how Mediology Co., Ltd. ("Mediology", "we", "us") may use and disclose your Protected Health Information ("PHI") collected through Healthier and how you can access your information.',
      },
      {
        text: 'We are required by the Health Insurance Portability and Accountability Act of 1996 ("HIPAA") to maintain the privacy of your PHI and to inform you of our legal duties and privacy practices with respect to your PHI.',
      },
    ],
  },
  {
    title: "2. Our Responsibilities",
    contents: [
      {
        text: "We are required by law to maintain the privacy of your PHI.",
        listType: true,
      },
      {
        text: "We will let you know promptly if a breach occurs that may have compromised the privacy or security of your PHI.",
        listType: true,
      },
      {
        text: "We must follow the duties and privacy practices described in this Notice and give you a copy upon request.",
        listType: true,
      },
      {
        text: "We will not use or share your information other than as described here unless you give us written permission.",
        listType: true,
      },
    ],
  },
  {
    title: "3. Your Rights",
    contents: [
      {
        text: "You have the right to:",
      },
      {
        text: "Access: You may request a copy of your PHI we maintain about you.",
        listType: true,
      },
      {
        text: "Amend: You may request corrections to your PHI if you believe it is incomplete or incorrect.",
        listType: true,
      },
      {
        text: "Accounting of Disclosures: You may request a list of disclosures of your PHI.",
        listType: true,
      },
      {
        text: "Request Restrictions: You may request restrictions on certain uses and disclosures of your PHI.",
        listType: true,
      },
      {
        text: "Request Confidential Communications: You may request that we contact you in a specific way.",
        listType: true,
      },
      {
        text: "Receive a Copy of This Notice: You may request a paper or electronic copy of this Notice.",
        listType: true,
      },
      {
        text: "To exercise any of these rights, please contact us at corp@mediology.ai.",
      },
    ],
  },
  {
    title: "4. How We May Use and Disclose Your PHI",
    contents: [
      {
        text: "We typically use or share your PHI in the following ways:",
      },
      {
        text: "To provide our services: We use your PHI to deliver personalized symptom assessments, health insights, and location-based health resources.",
        listType: true,
      },
      {
        text: "For operations: We use and share your PHI to improve Healthier, develop new features, and ensure quality services.",
        listType: true,
      },
      {
        text: "To comply with the law: We will share your PHI if required by federal, state, or local law.",
        listType: true,
      },
      {
        text: "To prevent serious threats: We may use or share your PHI when necessary to prevent a serious threat to your health or safety or the health and safety of others.",
        listType: true,
      },
      {
        text: "With your authorization: We may use or share your PHI for purposes not listed here only with your written authorization, which you may revoke at any time.",
        listType: true,
      },
    ],
  },
  {
    title: "5. Uses and Disclosures That Require Your Authorization",
    contents: [
      {
        text: "We will obtain your written authorization for:",
      },
      {
        text: "Marketing purposes using your PHI.",
        listType: true,
      },
      {
        text: "Sale of your PHI.",
        listType: true,
      },
      {
        text: "Any use or disclosure not described in this Notice.",
        listType: true,
      },
      {
        text: "You may revoke your authorization in writing at any time.",
      },
    ],
  },
  {
    title: "6. Our Commitment to Data Security",
    contents: [
      {
        text: "Mediology uses administrative, physical, and technical safeguards to protect your PHI, including:",
      },
      {
        text: "Encryption of PHI in transit and at rest.",
        listType: true,
      },
      {
        text: "Secure access controls and authentication.",
        listType: true,
      },
      {
        text: "Regular security audits and monitoring.",
        listType: true,
      },
    ],
  },
  {
    title: "7. Changes to This Notice",
    contents: [
      {
        text: "We reserve the right to change the terms of this Notice. If we make significant changes, we will post the updated Notice within the Healthier app and on our website, indicating the new effective date.",
      },
    ],
  },
  {
    title: "8. Questions or Complaints",
    contents: [
      {
        text: "If you have any questions about this Notice or believe your privacy rights have been violated, you may contact:",
      },
      {
        text: "Email: corp@mediology.ai",
        isBackground: true,
      },
      {
        text: "You may also file a complaint with the U.S. Department of Health and Human Services Office for Civil Rights. We will not retaliate against you for filing a complaint.",
      },
    ],
  },
  {
    title: "9. Contact Information",
    contents: [
      {
        text: "For all requests regarding your PHI or this Notice, contact:",
      },
      {
        text: "Privacy Officer\n\nMediology Co., Ltd.\n\nEmail: corp@mediology.ai",
        isBackground: true,
      },
    ],
  },
];

/*
{title : "",
contents : [],},


*/
